export function buildPreTreatmentAuthJson(paramsObj) {
    // let clientNamesArr = [];

    // try {
    //     clientNamesArr = paramsObj.client_names;
    // } catch(err) {
    //     // do nothing
    // }

    const json = {
        "title": "Treatment Pre-Authorisation form",
        "logoPosition": "right",
        "completedHtml": "<h3>Thank you for completing the pre-authorisation form! We'll be in touch soon.</h3>",
        "completedHtmlOnCondition": [
         {
          "expression": "{allergies} = true or {autoimmune} = true or {botox} = true or {chemicalpeels} = true or {claustrophobia} = true or {coldsores} = true or {contact_lenses} = true or {keloidblisterscoldsores} = true or {lastyearhealthproblems} = true or {light-based procedure} = true or {luminfusion_contraindications} anyof ['item1', 'item2', 'item3', 'item4', 'item5', 'item6', 'item7', 'item8', 'item9', 'item10', 'item11', 'item12', 'item13', 'item14', 'item15', 'item16', 'item17'] or {medications_supplements_vitamins} notempty or {metal_Implants_pacemaker} = true or {pregnant} anyof ['Pregnant', 'Trying To Become Pregnant', 'Lactating', 'Menstruating', 'Pre-Menstrual'] or {Products using} anyof ['Glycolic Acid', 'Lactic Acid', 'Other Hydroxy Acids', 'Any Exfoliating Scrubs', 'Vitamin A Derivatives (I.E., Retinol)', 'other'] or {question1} anyof ['item1', 'item2', 'item3', 'item4', 'item5', 'item6', 'item7', 'item8', 'item9', 'item10', 'item11', 'item12', 'item13', 'item14', 'item15', 'other'] or {question5} anyof ['item1', 'item2', 'item3', 'item4', 'item5', 'item6', 'item7', 'item8'] or {question9} anyof ['item1', 'item2', 'item3', 'item4', 'item5', 'item6', 'item7', 'item8', 'item9', 'item10', 'item11', 'item12', 'item13', 'item14', 'item15', 'item16', 'item17'] or {question13} anyof ['item1', 'item2', 'item3', 'item4', 'item5', 'item6', 'item7', 'item8', 'item9', 'item10', 'item11', 'item12', 'item13', 'item14', 'item15', 'item16', 'item17'] or {question18} anyof ['item1', 'item2', 'item3', 'item16', 'item4', 'item5', 'item6', 'item7', 'item8', 'item9', 'item10', 'item11', 'item12', 'item13', 'other'] or {question22} anyof ['item1', 'active eczema, psoriasis, and other chronic', 'condition flare up', 'item3', 'item4', 'item5', 'item6', 'item7'] or {redness itching stinging} = true or {retin-a, renova, adapalene} = true or {sinus} = true or {sunbathe tanning} = true or {waxed} = true",
          "html": "<h3>Thank you for completing the pre-authorisation form! Our records indicate potential contraindications to your selected treatment. Our team will review your submission and we'll be in touch soon.</h3>"
         }
        ],
        "pages": [
         {
          "name": "treatment-container",
          "elements": [
           {
            "type": "panel",
            "name": "clientdetails",
            "elements": [
             {
              "type": "html",
              "name": "authorisation_title",
              "html": {
               "default": "<h1 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">client treatment</span> pre-authorisation form</span></h1>",
               "it": "<h1 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">Modulo di autorizzazione</span> al trattamento del cliente</span></h1>",
               "nl": "<h1 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">Toestemmingsformulier Klant</span> voor behandeling</span></h1>",
               "et": "<h1 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">Kliendi hoolitsuse </span>nõusoleku vorm</span></h1>",
               "fi": "<h1 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">Asiakkaan ennakkoon</span> täytettävä lomake</span></h1>",
               "fr": "<h1 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">Formulaire d'autorisation</span> de soin</span></h1>",
               "gr": "<h1 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">Φόρμα Συγκατάθεσης</span> θεραπείας από τον πελάτη</span></h1>",
               "lv": "<h1 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">Procedūras</span> Atļaujas Anketa</span></h1>",
               "lt": "<h1 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">Kliento gydymo</span> sutikimo forma</span></h1>",
               "no": "<h1 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">Kundens behandlingsautorisasjon</span> og skjema</span></h1>",
               "pl": "<h1 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">formularz zgody</span> klienta na zabieg</span></h1>",
               "es": "<h1 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">Autorización de consulta</span> de tratamiento</span></h1>",
               "sv": "<h1 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">Medgivandeformulär</span> inför behandling</span></h1>",
               "tr": "<h1 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">Müşteri Bakım</span> Onay Formu</span></h1>",
               "vi": "<h1 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">mẫu uỷ quyền</span> trị liệu của khách hàng</span></h1>"
              }
             },
             {
              "type": "html",
              "name": "disclaimer",
              "html": {
               "default": "This is used to evaluate your individual skin care needs. We will maintain the confidentiality of this information and will disclose this information only: (i) to our staff members, (ii) to quality assurance and quality control personnel, (iii) to our product supplier and manufacturer. We will not provide this information to anyone else, except as required by law, and we will not sell this information to anyone. We may, however, contact you with product-related information.",
               "fr": "Ceci est utilisé pour évaluer vos besoins individuels de soins de la peau. Nous maintiendrons la confidentialité de ces informations et divulguerons ces informations uniquement: (i) à nos membres du personnel, (ii) au personnel d'assurance et de contrôle de la qualité, (iii) à notre fournisseur et fabricant de produits. Nous ne fournirons ces informations à personne d'autre, sauf si la loi l'exige, et nous ne vendrons ces informations à personne. Nous pouvons toutefois vous contacter avec des informations relatives au produit.",
               "it": "Viene utilizzato per valutare le esigenze individuali di cura della pelle. Manterremo la riservatezza di queste informazioni e divulgheremo queste informazioni solo: (i) ai membri del nostro personale, (ii) al personale addetto all'assicurazione e al controllo qualità, (iii) al nostro fornitore e produttore del prodotto. Non forniremo queste informazioni a nessun altro, ad eccezione di quanto richiesto dalla legge, e non venderemo queste informazioni a nessuno. Potremmo, tuttavia, contattarti con informazioni relative al prodotto.",
               "nl": "Dit wordt gebruikt om je individuele huidverzorgingsbehoeften te evalueren. We zullen de vertrouwelijkheid van deze informatie bewaren en zullen deze informatie alleen bekendmaken: (i) aan onze medewerkers, (ii) aan kwaliteitsborgings- en kwaliteitscontrolepersoneel, (iii) aan onze productleverancier en -fabrikant. We zullen deze informatie aan niemand anders verstrekken, behalve zoals vereist door de wet, en we zullen deze informatie aan niemand verkopen. We kunnen echter contact met je opnemen met productgerelateerde informatie.",
               "et": "Selle abil hinnatakse teie individuaalseid nahahoolduse vajadusi. Hoiame selle teabe konfidentsiaalsena ja avaldame selle teabe ainult: (i) oma töötajatele, (ii) kvaliteeditagamise ja -kontrolli töötajatele, (iii) meie toodete tarnijale ja tootjale. Me ei edasta seda teavet kellelegi teisele, välja arvatud seadusega ette nähtud juhtudel, ja me ei müü seda teavet kellelegi. Võime siiski tootega seotud teabe saamiseks teiega ühendust võtta.",
               "fi": "Tietoasi käytetään arvioimaan sinun yksilöllisiä ihonhoitotarpeitasi. Kaikki saamamme tiedot säilytetään luottamuksellisena tietona ja paljastetaan ainoastaan: (i) ihoterapeuteillemme, (ii) laadunvarmistuksen ja -valvonnan henkilöstölle, (iii) tavaramme toimittajalle ja valmistajalle. Tietojasi ei jaeta kenenkään muun kanssa ellei laki sitä vaadi. Emmekä myy tietojasi kenellekään. Voimme kuitenkin ottaa itse sinuun yhteyttä.",
               "de": "Dies wird benutzt, um deine individuellen Hautpflegebedürfnisse zu bewerten. Wir werden die Vertraulichkeit dieser Information wahren und diese Information nur (i) mit unseren Mitarbeitern, (ii) mit  Personal der Qualitätssicherung und Qualitätskontrolle und (iii) mit unserem Produktlieferant und -hersteller teilen. Wir werden diese Information an niemand anderen weitergeben, außer wie vom Gesetz vorgeschrieben, und wir werden diese Information an niemanden verkaufen. Wir werden dich jedoch vielleicht mit produktbezogenen Informationen kontaktieren.",
               "gr": "Αυτό το εργαλείο χρησιμοποιείται για να αξιολογήσει τις ατομικές ανάγκες φροντίδας του δέρματός σας. Θα διατηρήσουμε την εμπιστευτικότητα αυτών των πληροφοριών και θα αποκαλύψουμε αυτές τις πληροφορίες μόνο: (α) στα μέλη του προσωπικού μας, (β) στο προσωπικό διασφάλισης ποιότητας και ποιοτικού ελέγχου, (γ) στον προμηθευτή και τον κατασκευαστή των προϊόντων μας. Δεν θα παρέχουμε αυτές τις πληροφορίες σε κανέναν άλλο, εκτός εάν απαιτείται από το νόμο και δεν θα πουλήσουμε αυτές τις πληροφορίες σε κανέναν. Ωστόσο, ενδέχεται να επικοινωνήσουμε μαζί σας για πληροφορίες σχετικά με το προϊόν.",
               "ja": "ご記入頂きました内容は、個々のスキンケアのニーズを評価するために使用されます。私たちはこの情報の機密性を維持し、この情報を（i）当社のスタッフ、（ii）品質保証および品質管理担当者、（iii）製品供給元および製造者のみに開示します。法律で義務付けられている場合を除き、この情報を第三者に提供することはありません。また、この情報を第三者に販売することもありません。ただし、製品に関する情報をご連絡する場合があります。",
               "lv": "Tas tiek izmantots, lai novērtētu jūsu individuālās ādas kopšanas vajadzības. Mēs saglabāsim šīs informācijas konfidencialitāti un atklāsim šo informāciju tikai: (i) mūsu darbiniekiem, (ii) kvalitātes nodrošināšanas un kvalitātes kontroles personālam, (iii) mūsu produktu piegādātājam un ražotājam. Mēs nesniegsim šo informāciju nevienam citam, izņemot gadījumus, kad to pieprasa likumi, un mēs nepārdosim šo informāciju nevienam. Tomēr mēs, iespējams, sazināsimies ar jums par informāciju, kas saistīta ar produktu.",
               "lt": "Tai naudojama norint įvertinti Jūsų individualius odos priežiūros poreikius. Šios informacijos konfidencialumas bus išlaikytas ir atskleisime šią informaciją tik: i) savo darbuotojams, ii) kokybės užtikrinimo ir kokybės kontrolės darbuotojams, iii) gaminio tiekėjui ir gamintojui. Ši informacija niekam nebus perduota, išskyrus atvejus, kai to reikalauja įstatymai. Tačiau galime kreiptis į Jūs su produktu susijusios informacijos.",
               "no": "Dette blir brukt til å evaluere din individuelle hudpleiebehov. Denne informasjonen er konfidensiell, og vil kun være tilgjengelig for din terapeut, de ansatte og vår leverandør.",
               "pl": "Służy do oceny indywidualnych potrzeb w zakresie pielęgnacji skóry. Zachowamy poufność tych danych i ujawnimy te informacje tylko (i) naszym pracownikom, (ii) personelowi do zapewniania wysokiej jakości usług, (iii) naszemu dostawcy produktów i ich producentowi. Nie przekażemy tych informacji nikomu, z wyjątkiem przypadków wymaganych przez prawo, i nikomu nie sprzedamy tych informacji. Możemy jednak skontaktować się z Tobą w celu dostarczenia informacji związanych z produktem.",
               "es": "Esto se utiliza para evaluar sus necesidades individuales de cuidado de la piel. Mantendremos la confidencialidad de esta información y solo divulgaremos esta información: (i) a los miembros de nuestro personal, (ii) al personal de garantía y control de calidad, (iii) a nuestro proveedor y fabricante de productos. No proporcionaremos esta información a nadie más, salvo que lo exija la ley, y no venderemos esta información a nadie. Sin embargo, si podemos comunicarnos contigo, si nos parece oportuno, con información relacionada con el producto.",
               "sv": "Detta används för att utvärdera vad din hud behöver. Informationen du anger är konfidentiell och kommer endast vara tillgänglig för behövrig personal och vid kvalitetsanalyser. Ingen del av den här informationen kommer att delas vidare.",
               "tr": "Bu, kişisel cilt bakımı ihtiyaçlarınızı değerlendirmek için kullanılır. Bu bilgilerin gizliliği korunacak ve bu bilgiler  gerektiğinde sadece (i) çalışanlarımız, (ii) kalite güvence ve kalite kontrol personeli, (iii) ürün tedarikçimiz ve üreticimiz ile paylaşılacaktır. Bu bilgiler yasaların gerektirdiği durumlar dışında kimseye verilmeyecektir ve bu bilgiler hiç kimseye satılmayacaktır. Bununla birlikte, ürünle ilgili bilgilendirme amaçlı sizinle iletişime geçebiliriz.",
               "vi": "Ứng dụng này được sử dụng để đánh giá nhu cầu chăm sóc da cá nhân của bạn. Chúng tôi sẽ duy trì tính bảo mật của thông tin này và sẽ chỉ tiết lộ thông tin này: (i) cho nhân viên của chúng tôi, (ii) cho nhân viên kiểm soát chất lượng và đảm bảo chất lượng, (iii) cho nhà sản xuất và nhà cung cấp sản phẩm của chúng tôi. Chúng tôi sẽ không cung cấp thông tin này cho bất kỳ ai khác, ngoại trừ trường hợp luật pháp yêu cầu, và chúng tôi sẽ không bán thông tin này cho bất kỳ ai. Tuy nhiên, chúng tôi có thể liên hệ với bạn về thông tin liên quan đến sản phẩm."
              }
             },
             {
              "type": "multipletext",
              "name": "clientdata",
              "title": "New Client Information:",
              "titleLocation": "top",
              "hideNumber": true,
              "items": [
               {
                "name": "first_name",
                "isRequired": true,
                "title": "first name",
                "requiredErrorText": "You must enter your first name."
               },
               {
                "name": "surname",
                "isRequired": true,
                "title": "last name",
                "requiredErrorText": "You must enter your last name."
               },
               {
                "name": "email",
                "isRequired": true,
                "inputType": "email",
                "title": "email",
                "requiredErrorText": "You must enter your email address."
               },
               {
                "name": "birthday",
                "placeholder": "optional",
                "inputType": "date",
                "title": "birthday"
               },
               {
                "name": "address",
                "placeholder": "optional",
                "title": "address"
               },
               {
                "name": "apt_unit",
                "placeholder": "optional",
                "title": "Apt/unit"
               },
               {
                "name": "city",
                "placeholder": "optional",
                "title": "City"
               },
               {
                "name": "state",
                "placeholder": "optional",
                "title": "state"
               },
               {
                "name": "zip",
                "placeholder": "optional",
                "title": "zip"
               },
               {
                "name": "phone",
                "placeholder": "optional",
                "title": "phone"
               }
              ]
             }
            ]
           },
           {
            "type": "panel",
            "name": "treatment-questions",
            "elements": [
             {
              "type": "radiogroup",
              "name": "What treatment",
              "title": {
               "default": "What treatment are we pre-authorising you for?",
               "it": "Quale trattamento ha {{username}} oggi?",
               "es": "¿Qué tratamiento está recibiendo hoy?",
               "tr": "Kişi bugün hangi bakımı yaptıracak?",
               "vi": "Liệu trình nào bạn sẽ thực hiện hôm nay?"
              },
              "isRequired": true,
              "choices": [
               {
                "value": "pro_skin",
                "text": "ProSkin"
               },
               {
                "value": "nano_infusion",
                "text": {
                 "default": "NanoInfusion",
                 "vi": "Siêu vi kim Nanoneedling"
                }
               },
               {
                "value": "IPL",
                "text": {
                 "default": "IPL",
                 "vi": "Ánh sáng xung độ cao IPL"
                }
               },
               {
                "value": "pro_power_peel",
                "text": {
                 "default": "Pro Power Peel",
                 "ja": "プロパワーピール",
                 "lt": "Pro Power pilingas",
                 "vi": "Lột Tẩy Quyền Năng Chuyên Nghiệp Pro Power Peel"
                }
               },
               {
                "value": "dermaplaning",
                "text": {
                 "default": "Dermaplaning",
                 "vi": "Cạo lông tơ Dermaplaning"
                }
               },
               {
                "value": "fibroblast",
                "text": {
                 "default": "Fibroblast Skin Tightening",
                 "vi": "Liệu pháp Fibroblast"
                }
               },
               {
                "value": "microneedling",
                "text": {
                 "default": "Microneedling",
                 "vi": "Vi kim Microneedling"
                }
               },
               {
                "value": "lumin_fusion",
                "text": "LuminFusion"
               }
              ],
              "showOtherItem": true,
              "otherText": "Other"
             },
             {
              "type": "boolean",
              "name": "lastyearhealthproblems",
              "title": {
               "default": "Within the last year, have you had any health problems that have affected or could affect your skin?",
               "fr": "Au cours des 12 derniers mois, avez-vous consulté un médecin ou un dermatologue ?",
               "de": "Hast du innerhalb des letzten Jahres einen Arzt konsultiert/ Medizin genommen / Allergien gehabt?",
               "nl": "Heb je in het afgelopen jaar gezondheidsproblemen gehad die de huid beïnvloedden of konden beïnvloeden?",
               "es": "¿en el último año has estado en tratamiento médico/ tomando medicación/ o tienes alguna alergia?",
               "pl": "Czy w ciągu ostatniego roku miałeś jakieś problemy zdrowotne, które wpłynęły lub mogą wpłynąć na Twoją skórę?",
               "lv": "Vai pēdējā gada laikā esat bijis ārsta uzraudzībā / lietojis medikamentus / vai ir kādas alerģijas?",
               "no": "Har du i løpet av det siste året blitt behandlet av lege / gått på medisiner / hatt allergier?",
               "da": "Er du indenfor det sidste år blevet behandlet af en læge / fået medicin / eller har du nogen allergier?",
               "gr": "Είσασταν μέσα στον τελευταίο χρόνο υπό ιατρική παρακολούθηση / λαμβάνατε φαρμακευτική αγωγή / έχετε αλλεργίες;",
               "fi": "Oletko viimeisen vuoden aikana ollut lääkärin hoidossa / onko sinulla ollut lääkityksiä / onko sinulla ollut allergioita?",
               "ja": "過去1年間に、あなたは医師の治療下にありますか/薬による治療を受けていますか/アレルギーがありますか？",
               "it": "Durante l'ultimo anno, ha avuto qualche malattia che ha colpito o potrebbe colpire la sua pelle?",
               "et": "Kas teil on viimase aasta jooksul olnud terviseprobleeme, mis on mõjutanud või võivad mõjutada teie nahka?",
               "lt": "Ar per pastaruosius metus turėjote sveikatos problemų, kurios paveikė ar galėjo paveikti jūsų odą?",
               "sv": "Har du under det senaste året haft något problem med hälsan och som kan ha påverkat din hud?",
               "tr": "Geçtiğimiz son 1 yıl içinde cildinizi etkileyen veya etkileyebilecek herhangi bir sağlık problemi yaşadınız mı?",
               "vi": "Trong năm qua, bạn có bất kỳ vấn đề về sức khoẻ nào gây ảnh hưởng hoặc có khả năng ảnh hưởng đến làn da của bạn?"
              },
              "isRequired": true
             },
             {
              "type": "comment",
              "name": "IfYesPleaseExplain",
              "visibleIf": "{lastyearhealthproblems} = true",
              "title": {
               "default": "If Yes, please explain:",
               "nl": "Zo ja, leg uit:",
               "lv": "Ja jā, lūdzu, paskaidrojiet:",
               "no": "Hvis ja, vennligst forklar:",
               "gr": "Εάν ναι, εξηγήστε:",
               "pl": "Jeśli tak, proszę wyjaśnić",
               "fi": "Jos kyllä, ole hyvä ja selvennä",
               "lt": "\"Ja jā, lūdzu, paskaidrojiet",
               "sv": "Om Ja, vänligen förklara",
               "fr": "Si oui, veuillez expliquer:",
               "it": "Se SI, aggiungere una descrizione",
               "et": "Kui jah, palun selgitage",
               "ja": "はいの場合、説明してください。",
               "es": "En caso afirmativo, explique por favor:",
               "tr": "Eğer evet ise, lütfen açıklayın",
               "vi": "Nếu Có, vui lòng giải thích"
              },
              "hideNumber": true,
              "enableIf": "{lastyearhealthproblems} = true"
             },
             {
              "type": "boolean",
              "name": "keloidblisterscoldsores",
              "title": {
               "default": "Are you prone to keloid scarring, blisters, or cold sores?",
               "de": "Trägst du Kontaktlinsen?",
               "fr": "Portez-vous des lentilles?",
               "nl": "Draag je contactlenzen?",
               "es": "¿llevas lentillas?",
               "it": "Porti le lenti a contatto?",
               "pl": "Czy nosisz szkła kontaktowe?",
               "lv": "Vai jūs nēsājat kontaktlēcas?",
               "no": "Bruker du kontaktlinser?",
               "da": "Bruger kontaktlinser?",
               "gr": "Φοράτε φακούς επαφής;",
               "fi": "Käytätkö piilolinssejä?",
               "ja": "コンタクトレンズを使用していますか？",
               "et": "Kas te kannate kontaktläätsi?",
               "lt": "Ar dėvite kontaklinius lęšius?",
               "sv": "Bär du kontaktlinser?",
               "tr": "Kontakt lens kullanıyor musunuz?",
               "vi": "Bạn có đeo kính áp tròng?"
              },
              "isRequired": true
             },
             {
              "type": "text",
              "name": "medications_supplements_vitamins",
              "title": {
               "default": "List any medications, supplements, vitamins, diuretics, slimming pills, oral contraceptives, Isotretinoin, etc. that you take regularly",
               "fr": "Indiquez les médicaments, compléments alimentaires, vitamines, comprimés amincissants que vous prenez régulièrement",
               "de": "Gib bitte alle Medikamente, Nahrungsergänzungsmittel, Vitamine, Diuretika, Diätpillen, orale Kontrazeptiva, Isotretin etc. an, die du regelmäßig einnimmst",
               "nl": "Benoem alle medicijnen, supplementen, vitaminen, diuretica, afslankpillen, orale anticonceptiva, Isotretinoïne, enz. die je regelmatig neemt",
               "es": "Ennumera los medicamentos, suplementos alimenticios, vitaminas, diuréticos, pastillas adelagazantes, anticonceptivos orales, isoretinoin, etc que tomas regularmente.",
               "it": "Lista di medicazioni, supplementi, vitamine, diuretici, pillole dimagranti",
               "pl": "Wymień wszystkie leki, suplementy, witaminy, leki moczopędne, tabletki odchudzające, doustne środki antykoncepcyjne, izotretynoinę itp., które regularnie zażywasz",
               "lv": "Uzskaitiet visus medikamentus, piedevas, vitamīnus, diurētiskos līdzekļus, novājēšanas tabletes, perorālos kontracepcijas līdzekļus, izotretinoīnu utt., ko lietojat regulāri",
               "no": "Notér medisiner, p-piller, kosttilskudd, vitaminer osv, som du tar regelmessig.",
               "da": "Angiv alle typer medicin, kosttilskud, vitaminer, vanddrivende, slanketabletter, hormonbehandling (p-piller, spiral eller lign), acnemedicin osv. du tager regelmæssigt",
               "gr": "Αναφέρετε κάποια φάρμακα, βιταμίνες, συμπληρώματα διατροφής, διουρητικά, χάπια αδυνατίσματος,Ισοτρετινοίνη κ.λ.π. που χρησιμοποιείτε συχνά",
               "fi": "Listaa kaikki säännöllisesti käyttämäsi lääkkeet, lisäravinteet, vitamiinit, nesteenpoisto- tai laihdutusvalmisteet, ehkäisypillerit, isotretioniini jne.",
               "ja": "薬、サプリメント、ビタミン剤、下剤、ダイエット錠剤、イソトレチノイン、経口避妊薬など、定期的に服用している物はありますか？",
               "et": "Loetlege ravimid, toidulisandid, vitamiinid, diureetikumid, salenemistabletid, suukaudsed rasestumisvastased vahendid, isotretinoiin jne, mida te regulaarselt kasutate",
               "lt": "Išvardinkite visus vaistus, papildus, vitaminus, diuretikus, lieknėjimo tabletes, geriamuosius kontraceptikus, izotretinoiną ir kt., kuriuos vartojate reguliariai",
               "sv": "Vänligen specificera om du använder/nyligen har använt några receptbelagda läkemedel eller aktiva kosttillskott.",
               "tr": "Düzenli olarak aldığınız ilaçları, takviyeleri, vitaminleri, idrar söktürücü, zayıflama hapı, doğum kontrol hapı, izotretinoin vb.ilaçları yazınız.",
               "vi": "Liệt kê bất kỳ thuốc kê toa, thuốc bổ sung, vitamins, thuốc lợi tiểu, thuốc giảm cân, thuốc uống tránh thai, Isotrtinoin, v.v... mà bạn thường uống."
              }
             },
             {
              "type": "boolean",
              "name": "autoimmune",
              "title": {
               "default": "Do you have any other medical condition, or autoimmunediseases such as Lupus, contraindicated by your physician foradvanced treatments?",
               "de": "Trägst du Kontaktlinsen?",
               "fr": "Portez-vous des lentilles?",
               "nl": "Draag je contactlenzen?",
               "es": "¿llevas lentillas?",
               "it": "Porti le lenti a contatto?",
               "pl": "Czy nosisz szkła kontaktowe?",
               "lv": "Vai jūs nēsājat kontaktlēcas?",
               "no": "Bruker du kontaktlinser?",
               "da": "Bruger kontaktlinser?",
               "gr": "Φοράτε φακούς επαφής;",
               "fi": "Käytätkö piilolinssejä?",
               "ja": "コンタクトレンズを使用していますか？",
               "et": "Kas te kannate kontaktläätsi?",
               "lt": "Ar dėvite kontaklinius lęšius?",
               "sv": "Bär du kontaktlinser?",
               "tr": "Kontakt lens kullanıyor musunuz?",
               "vi": "Bạn có đeo kính áp tròng?"
              },
              "isRequired": true
             },
             {
              "type": "boolean",
              "name": "contact_lenses",
              "title": {
               "default": "Do you wear contact lenses?",
               "de": "Trägst du Kontaktlinsen?",
               "fr": "Portez-vous des lentilles?",
               "nl": "Draag je contactlenzen?",
               "es": "¿llevas lentillas?",
               "it": "Porti le lenti a contatto?",
               "pl": "Czy nosisz szkła kontaktowe?",
               "lv": "Vai jūs nēsājat kontaktlēcas?",
               "no": "Bruker du kontaktlinser?",
               "da": "Bruger kontaktlinser?",
               "gr": "Φοράτε φακούς επαφής;",
               "fi": "Käytätkö piilolinssejä?",
               "ja": "コンタクトレンズを使用していますか？",
               "et": "Kas te kannate kontaktläätsi?",
               "lt": "Ar dėvite kontaklinius lęšius?",
               "sv": "Bär du kontaktlinser?",
               "tr": "Kontakt lens kullanıyor musunuz?",
               "vi": "Bạn có đeo kính áp tròng?"
              },
              "isRequired": true
             },
             {
              "type": "boolean",
              "name": "metal_Implants_pacemaker",
              "title": {
               "default": "Do you have metal implants, a pacemaker or body piercings?",
               "fr": "Avez-vous des implants en métal, un stimulateur cardiaque ou des piercings?",
               "de": "Hast du Metallimplantate, einen Herzschrittmacher oder Körperpiercings?",
               "nl": "Heb je metalen implantaten, pacemaker of bodypiercings?",
               "es": "¿llevas implantes metálicos, marcapasos o piercings?",
               "pl": "Czy posiadasz metalowe implanty, rozrusznik serca lub kolczyki w ciele?",
               "lv": "Vai jums ir metāla implanti, elektrokardiostimulators vai ķermeņa pīrsingi?",
               "no": "Har du metallimplantater, pacemaker eller piercinger?",
               "it": "Hai qualche protesi metallica, peacemaker o piercing?",
               "da": "Har du nogen metalimplantater, pacemaker eller kropspiercinger?",
               "gr": "Έχετε μεταλλικά πρόσθετα ή βηματοδότη ή body piercings;",
               "fi": "Onko sinulla metalli-implantti, sydämentahdistin tai lävistyksiä?",
               "ja": "金属インプラント、ペースメーカー、ボディピアスなどを付けていますか？",
               "et": "Kas teil on metallist implantaate, südamestimulaatorit või metallist kehaehteid?",
               "lt": "Ar turite metalinius implantus, širdies stimuliatorių ar kūno auskarus?",
               "sv": "Har du några metallinplantat, piercings eller pacemaker?",
               "tr": "Vücudunuzda metal implant, kalp pili veya piercing var mı?",
               "vi": "Bạn có đang cấy ghép kim loại, máy trợ tim hoặc đeo khuyên trên cơ thể?"
              },
              "isRequired": true
             },
             {
              "type": "boolean",
              "name": "allergies",
              "title": {
               "default": "Do you have any allergies?",
               "fr": "Avez-vous des allergies?",
               "de": "Hast du irgendwelche Allergien?",
               "nl": "Heb je last van allergieën?",
               "es": "¿llevas implantes metálicos, marcapasos o piercings?",
               "it": "Hai qualche allergia?",
               "pl": "Czy posiadasz jakieś alergie?",
               "lv": "Vai jums ir alerģijas?",
               "no": "Har du allergier?",
               "da": "Har du nogen allergier?",
               "gr": "Έχετε αλλεργίες;",
               "fi": "Onko sinulla allergioita?",
               "ja": "アレルギーはありますか？",
               "et": "Kas teil esineb allergiaid?",
               "lt": "Ar turite kokių alergijų?",
               "sv": "Har du några allergier?",
               "tr": "Herhangi bir alerjiniz var mı?",
               "vi": "Bạn có bất kỳ dị ứng gì?"
              },
              "isRequired": true
             },
             {
              "type": "text",
              "name": "pleaseexplain",
              "visibleIf": "{allergies} = true",
              "title": {
               "default": "If yes, please specify:",
               "gr": "Εάν ναι, εξηγήστε",
               "et": "Kui jah, palun selgitage",
               "fi": "Jos kyllä, ole hyvä ja selvennä",
               "pl": "Jeśli tak, proszę wyjaśnić",
               "lv": "Jei, taip, prašome paaiškinkite",
               "lt": "Ja jā, lūdzu, paskaidrojiet",
               "no": "Hvis ja, vennligst forklar",
               "nl": "Zo ja, leg uit",
               "sv": "Om Ja, vänligen förklara",
               "fr": "Si oui, veuillez expliquer:",
               "it": "Se SI, aggiungere una descrizione",
               "ja": "はいの場合、説明してください。",
               "es": "En caso afirmativo, explique por favor",
               "tr": "Eğer evet ise, lütfen açıklayın",
               "vi": "Nếu Có, vui lòng giải thích"
              },
              "hideNumber": true,
              "enableIf": "{allergies} = true"
             },
             {
              "type": "boolean",
              "name": "sinus",
              "title": {
               "default": "Do you have sinus problems?",
               "fr": "Avez-vous des problèmes de sinus?",
               "de": "Hast du Nasennebenhöhlenprobleme?",
               "nl": "Heb je sinusklachten?",
               "es": "¿tienes problemas de sinusales?",
               "it": "Hai problemi sinusali?",
               "pl": "Czy masz problemy z zatokami?",
               "lv": "Vai jums ir sinusa problēmas?",
               "no": "Har du problemer med bihulene?",
               "da": "Har du problemer med bihulerne?",
               "gr": "Υποφέρετε από ιγμόρειο;",
               "fi": "Onko sinulla taipumusta poskiontelotulehduksiin",
               "ja": "鼻づまりしやすいですか？",
               "et": "Kas teil esineb probleeme ninasiinustega/põskkoobastega?",
               "lt": "Ar turite sinusitą?",
               "sv": "Har du återkommande bihåleproblem?",
               "tr": "Sinüzit probleminiz var mı?",
               "vi": "Bạn có vấn đề về xoang?"
              },
              "isRequired": true
             },
             {
              "type": "boolean",
              "name": "claustrophobia",
              "title": {
               "default": "Have you ever experienced claustrophobia?",
               "fr": "Souffrez-vous de claustrophobie?",
               "de": "Hast du Nasennebenhöhlenprobleme?",
               "nl": "Heb je eerder last gehad van claustrofobie?",
               "es": "¿tienes problemas de sinusales?",
               "it": "Hai problemi sinusali?",
               "pl": "Czy cierpisz na klaustrofobię?",
               "lv": "Vai esat kādreiz pieredzējis klaustrofobiju?",
               "no": "Har du opplevd klaustroforbi?",
               "da": "Lider du af klaustrofobi?",
               "gr": "Είχατε ποτέ πρόβλημα κλειστοφοβίας;",
               "fi": "Oletko koskaan kokenut ahtaanpaikankammoa",
               "ja": "閉所恐怖症になった事はありますか？",
               "et": "Kas teil esineb klaustrofoobiat?",
               "lt": "Ar sergate klaustrofobiją?",
               "sv": "Har du klaustrofobi?",
               "tr": "Klostrofobiniz var mı?",
               "vi": "Bạn đã từng trải qua chứng sợ ngột ngạt chưa?"
              },
              "isRequired": true
             },
             {
              "type": "comment",
              "name": "specific_challenges_skin",
              "title": {
               "default": "What are your specific concerns/challenges with your skin?",
               "fr": "Quels sont vos principaux objectifs pour votre peau?",
               "de": "Was sind spezifische Bedenken/Probleme mit deiner Haut?",
               "nl": "Wat zijn je specifieke zorgen / uitdagingen voor je huid?",
               "es": "¿cuáles son tus principales problemas o preocupaciones de la piel?",
               "pl": "Czy masz szczególne problemy/wyzwania związane ze skórą?",
               "lv": "Kādas ir jūsu īpašās problēmas / izaicinājumi ar ādu?",
               "no": "Hva er du opptatt av med huden din / har du noen spesielle utfordringer?",
               "it": "Quali sono le cose che vorresti migliorare della tua pelle?",
               "da": "Hvad er dine specifikke bekymringer/udfordringer med din hud?",
               "gr": "Τι επιθυμείτε από τη σημερινή αισθητική σας φροντίδα;",
               "fi": "Mitkä ovat ihosi päähuolenaiheet/haasteet?",
               "ja": "肌の悩み／気になることは何ですか？",
               "et": "Millised on teie nahaga seotud spetsiifilised probleemid?",
               "lt": "Kokie yra specifiniai Jūsų odos rūpesčiai / poreikiai?",
               "sv": "Har du några specifika problem eller önskemål när det gäller din hud?",
               "tr": "Cildinizle ilgili ihtiyaçlarınız/zorluklarınız neler?",
               "vi": "Những quan tâm / lo lắng cụ thể trên làn da của bạn là gì?"
              }
             },
             {
              "type": "checkbox",
              "name": "ProductsSoapCleanserToner",
              "title": {
               "default": "Which skin care products are you currently using?",
               "pl": "Których z poniższych rodzajów produktów aktualnie używasz?",
               "fr": "Parmi les produits suivants, lesquels utilisez-vous actuellement ?",
               "no": "Hvilke av de følgende produktene bruker du allerede?",
               "fi": "Mitä seuraavista tuotteista käytät tällä hetkellä",
               "it": "Stai usando o hai usato di recente",
               "nl": "Welke van de volgende producten gebruikt u momenteel?",
               "et": "Milliseid järgnevatest toodetest te praegu kasutate?",
               "gr": "Ποια από τα ακόλουθα προϊόντα χρησιμοποιείτε αυτήν τη στιγμή;",
               "ja": "現在使用している製品はどれですか？",
               "lv": "Kurus no šiem produktiem pašlaik izmantojat?",
               "lt": "Kurį iš šių produktų naudojate šiuo metu?",
               "es": "¿Cuáles de los siguientes productos usas habitualmente?",
               "tr": "Şu anda aşağıdaki ürünlerden hangilerini kullanıyorsunuz?",
               "vi": "Hiện tại bạn đang sử dụng những sản phẩm nào bên dưới đây?"
              },
              "choices": [
               {
                "value": "Soap",
                "text": {
                 "fr": "Démaquillant",
                 "de": "Seife",
                 "nl": "Zeep",
                 "pl": "Mydło",
                 "lv": "Ziepes",
                 "no": "Såpe",
                 "it": "Sapone",
                 "gr": "Σαπούνι",
                 "fi": "Saippua",
                 "ja": "石鹸",
                 "default": "Soap",
                 "et": "Seep",
                 "lt": "Muilas",
                 "sv": "Tvål",
                 "tr": "Sabun",
                 "vi": "Xà phòng"
                }
               },
               {
                "value": "Cleanser",
                "text": {
                 "fr": "Nettoyant",
                 "de": "Reinigungsmittel",
                 "nl": "Reinigingsmiddel",
                 "pl": "Preparat Oczyszczający",
                 "lv": "Sejas Mazgāšanas Līdzeklis",
                 "no": "Rens",
                 "it": "Detergenti",
                 "gr": "Καθαριστικό",
                 "fi": "Puhdistus",
                 "ja": "クレンザー（洗顔）",
                 "default": "Cleanser",
                 "et": "Puhastustoode",
                 "lt": "Prausiklis",
                 "sv": "Rengöring",
                 "tr": "Temizleyici",
                 "vi": "Sữa rửa mặt"
                }
               },
               {
                "value": "Toner",
                "text": {
                 "fr": "Tonique Et Lotion",
                 "lv": "Toniks",
                 "it": "Tonici",
                 "es": "Tónico",
                 "gr": "Λοσιόν",
                 "fi": "Kasvovesi",
                 "ja": "化粧水",
                 "default": "Toner",
                 "et": "Toonikud",
                 "lt": "Tonikai",
                 "sv": "Ansiktsvatten",
                 "tr": "tonik",
                 "vi": "toner"
                }
               },
               {
                "value": "Moisturizer",
                "text": {
                 "fr": "Hydratant",
                 "de": "Feuchtigkeitscreme",
                 "nl": "Moisturiser",
                 "pl": "Krem Nawilżający",
                 "lv": "Krēms",
                 "no": "Fuktighetskrem",
                 "it": "Idratanti",
                 "gr": "Ενυδατικό",
                 "fi": "Kosteusvoide",
                 "ja": "モイスチャライザー（クリーム・乳液）",
                 "default": "Moisturizer",
                 "et": "Kreem",
                 "lt": "Drėkiklis",
                 "sv": "Mjukgörare",
                 "tr": "Nemlendirici",
                 "vi": "Kem dưỡng"
                }
               },
               {
                "value": "Masque",
                "text": {
                 "nl": "Masker",
                 "es": "Mascarilla",
                 "pl": "Maska",
                 "lv": "Maska",
                 "no": "Maske",
                 "it": "Maschere",
                 "gr": "Μάσκα",
                 "fi": "Naamio",
                 "ja": "マスク",
                 "default": "Masque",
                 "et": "Mask",
                 "lt": "Kaukė",
                 "sv": "Mask",
                 "tr": "Maske",
                 "vi": "Mặt nạ"
                }
               },
               {
                "value": "Exfoliant",
                "text": {
                 "pl": "Peeling",
                 "lv": "Eksfoliants",
                 "no": "Eksfoliant",
                 "it": "Esfolianti",
                 "nl": "Exfoliërend",
                 "de": "Peeling",
                 "gr": "Απολεπιστικό",
                 "fi": "Kuorinta",
                 "ja": "角質除去剤",
                 "default": "Exfoliant",
                 "et": "Koorija",
                 "lt": "Šveitikliai",
                 "sv": "Exfoliering",
                 "tr": "Eksfoliant",
                 "vi": "Tẩy da chết"
                }
               },
               {
                "value": "Eye Product",
                "text": {
                 "pl": "Produkt na okolicę oczu",
                 "lv": "Acu Produkts",
                 "no": "Øyeprodukt",
                 "it": "Prodotti occhi",
                 "nl": "Oogproduct",
                 "de": "Augenprodukt",
                 "fr": "Soin Pour Les Yeux",
                 "gr": "Προϊόντα Ματιών",
                 "fi": "Silmänympärystuote",
                 "ja": "アイケア製品",
                 "default": "Eye Product",
                 "et": "Silmahooldus",
                 "lt": "Paakių odos produktai",
                 "sv": "Ögonprodukt",
                 "tr": "Göz Bakımı",
                 "vi": "Sản phẩm dành cho vùng mắt"
                }
               }
              ],
              "showOtherItem": true
             },
             {
              "type": "boolean",
              "name": "chemicalpeels",
              "title": {
               "default": "Have you had chemical peels, microdermabrasion or any resurfacing treatments within the last 2 weeks?",
               "fr": "Avez-vous effectué des peelings chimiques, une microdermabrasion ou un traitement d'exfoliation au cours des 3 derniers mois?",
               "de": "Hattest du in den letzten drei Monaten chemische Peelings, Mikrodermabrasionen oder andere erneuernde Behandlungen?",
               "nl": "Heb je een chemische peeling, laserbehandeling of (micro)dermabrasie gehad in de afgelopen drie maanden?",
               "es": "¿te has realizado en los últimos tres meses un peeling químico, microdermoabrasión, o algún tratamiento rejuvenecedor?",
               "it": "Hai mai fatto un peeling chimico, mircodermoabrasione o qualsiasi esfoliazione?",
               "pl": "Czy miałaś/eś wykonywany peeling chemiczny, mikrodermabrazję lub jakikolwiek inny zabieg złuszczający w przeciągu ostatnich trzech miesięcy?",
               "lv": "Vai pēdējā gada laikā esat bijis ārsta uzraudzībā / lietojis medikamentus / vai ir kādas alerģijas?",
               "no": "Har du fått utført hudsliping, kjemisk peeling eller laser i løpet av de siste månedene?",
               "da": "Er du blevet behandlet med kemisk peeling, laser eller hudslibning indenfor de sidste 3 måneder",
               "gr": "Έχετε κάνει χημική απολέπιση, μικροδερμοαπόξεση ή άλλης μορφής επεμβατική διαδικασία το τελευταίο τρίμηνο;",
               "fi": "Oletko käynyt kemiallisessa kuorinnassa, mikrohionnassa tai muussa kuorintahoidossa viimeisten kolmen kuukauden aikana?",
               "ja": "ケミカルピーリング、マイクロダーマブレージョン、その他リサーフェシングトリートメントを3か月以内に受けたことがありますか？",
               "lt": "Ar per pastaruosius tris mėnesius atlikote cheminį pilingą, mikrodermabraziją ar bet kokį kitą veido valymą?",
               "sv": "Har din hud behandlats med kemisk peeling, mikrodermabrasion eller microneedling de senaste tre månaderna?",
               "tr": "Son 2 hafta içinde kimyasal peeling, mikrodermabrazyon veya herhangi bir peeling yaptırdınız mı?",
               "vi": "Bạn có sử dụng lột tẩy hoá học, siêu mài mòn hoặc bất kỳ trị liệu tái tạo bề mặt da trong vòng ba tháng qua?"
              },
              "isRequired": true
             },
             {
              "type": "boolean",
              "name": "waxed",
              "title": {
               "default": "Have you been waxed within the last 1-2 weeks?",
               "fr": "Avez-vous effectué une épilation à la cire au cours des dernières 72 heures?",
               "de": "Wurdest du in den letzten 72 Stunden gewachst?",
               "nl": "Heb je je in de afgelopen 72 uur geharst / laten harsen?",
               "es": "¿te has depilado en las últimas 72 horas?",
               "it": "Hai fatto la ceretta nelle ultime 72 ore?",
               "pl": "Czy w ciągu ostatnich 72 godzin miałaś/eś wykonywaną depilację woskiem?",
               "lv": "Vai esat vaksēts pēdējo 72 stundu laikā?",
               "no": "Har du blitt vokset i ansiktet i løpet av de siste 72 timene?",
               "da": "Er du blevet vokset indenfor de sidste 72 timer?",
               "gr": "Έχετε κάνει αποτρίχωση τις τελευταίες 72 ώρες;",
               "fi": "Oletko käynyt vahauksessa viimeisen 72 tunnin aikana?",
               "ja": "72時間以内にワックストリートメントを受けていますか？",
               "lt": "Ar per pastarasias 72h atlikote depiliavimą vašku?",
               "sv": "Har du vaxat området vi ska behandla idag inom de senaste 72 timmarna?",
               "tr": "Son 1-2 hafta içinde sir ağda yaptırdınız mı?",
               "vi": "Bạn có vừa tẩy lông trong vòng 72 giờ qua?"
              },
              "isRequired": true
             },
             {
              "type": "boolean",
              "name": "retin-a, renova, adapalene",
              "title": {
               "default": "Have you used retinol, tretinoin or any other prescription skinproducts within the last three months?",
               "de": "Hast du in den letzten drei Monaten Retin-A, Renova, Adapalene oder andere verschreibungspflichtige Hautprodukte benutzt?",
               "nl": "Heb je Retin-A, Renova, Adapalene, RoAccutane of andere voorgeschreven huidverdunnende medicatie gebruikt in de afgelopen drie maanden?",
               "es": "¿Has usado en los últimos tres meses retin-A, Renova, Adapalene o algún otro producto de cuidado facial bajo prescripción?",
               "it": "Hai mai utilizzato Retin-A, Renova, Adapalene o qualsiasi altro medicinale per",
               "pl": "Czy w ciągu ostatnich 3 miesięcy stosowałaś/eś Retin-A, Renova, Adapalen lub jakiekolwiek inne preparaty dermatologiczne na receptę?",
               "lv": "Vai pēdējo trīs mēnešu laikā esat lietojis Retin-A, Renova, Adapalene vai citus recepšu produktus ādas ārstēšanai?",
               "da": "Har du anvendt A-vitaminsyre, hormoncremer eller andre receptpligtige cremer inden for de sidste 3 måneder?",
               "gr": "Έχετε χρησιμοποιήσει Accutane, Retin-A, Renova, Adapalene ή άλλο συνταγογραφούμενο προϊόν τους τελευταίους 3 μήνες;",
               "fi": "Oletko käyttänyt reseptillä määrättyjä retinolia sisältäviä ihonhoitotuotteita viimeisen kolmen kuukauden aikana?",
               "ja": "レチンＡ、レノバ、アダパレンやその他の医療処方された薬品を3ヶ月以内に使用していますか？",
               "no": "Har du brukt A-vitaminsyre eller andre reseptbelagte produkter de siste tre månedene?",
               "fr": "Avez-vous suivi un traitement à base d'Isotrétinoïde (Roaccutane) au cours des six derniers mois ?",
               "et": "Kas olete viimase kolme kuu jooksul kasutanud Retin-A, Renova, Adapalene või mõnda muud retseptiga naharavi toodet?",
               "lt": "Ar per pastaruosius tris mėnesius naudojote Retin-A, Renova, Adapalene ar bet kuriuos kitus receptinius odos produktus?",
               "sv": "Har du använt starkt uttorkande/exfolierande läkemedel/hudvårdsprodukter de senaste 3 månaderna?",
               "tr": "Son 3 ay içinde Retin-A, Renova, Adapalene veya benzeri bir medikal eksfoliasyon ilacı kullandınız mı?",
               "vi": "Bạn có sử dụng Retin-A, Renova, Adapalene hoặc bất kỳ sản phẩm chăm sóc da kê toa trong vòng ba tháng qua?"
              },
              "isRequired": true
             },
             {
              "type": "checkbox",
              "name": "Products using",
              "title": {
               "default": "Are you currently using any products that contain the following ingredients?",
               "fr": "Utilisez-vous actuellement des produits qui contiennent les ingrédients suivants ?",
               "de": "Benutzt du zur Zeit irgendwelche Produkte, die die folgenden Inhaltsstoffe enthalten?",
               "nl": "Gebruik je momenteel producten die de volgende ingrediënten bevatten?",
               "es": "¿estás usando ahora productos que contengan los siguientes ingredientes?",
               "it": "Stai utilizzando un prodotto che contiene i seguenti",
               "pl": "Czy stosujesz aktualnie produkty zawierające którykolwiek z tych składników?",
               "lv": "Vai jūs šobrīd lietojat produktus, kas satur šādas sastāvdaļas?",
               "no": "Bruker du produkter som inneholder noen av de følgende ingrediensene?",
               "da": "Bruger du for øjeblikket produkter, som indeholder følgende ingredienser?",
               "gr": "Χρησιμοποιείτε κάποια προϊόντα που εμπεριέχουν τα ακόλουθα συστατικά;",
               "fi": "Käytätkö tällä hetkellä ihonhoitotuotteita, jotka sisältävät seuraavia ainesosia?",
               "ja": "下記成分が配合された製品を現在使用中ですか？",
               "et": "Kas kasutate praegu tooteid, mis sisaldavad järgmisi koostisosi?",
               "lt": "Ar šiuo metu naudojate produktus, kuriuose yra šie ingredientai?",
               "sv": "Använder du just nu någon produkt som innehåller följande ingredienser?",
               "tr": "Şu anda aşağıdaki içeriklere sahip herhangi bir ürün kullanıyor musunuz?",
               "vi": "Bạn hiện có đang sử dụng bất kỳ sản phẩm có chứa các thàng phần sau?"
              },
              "choices": [
               {
                "value": "Glycolic Acid",
                "text": {
                 "fr": "Acide Glycolique",
                 "de": "Glykolsäure",
                 "nl": "Glycolzuur",
                 "it": "Acido Glicolico",
                 "pl": "kwas glikolowy",
                 "lv": "Glikolskābe",
                 "no": "Glykolsyre",
                 "gr": "Γλυκολικό Οξύ",
                 "fi": "Glykolihappo",
                 "ja": "グリコール酸",
                 "default": "Glycolic Acid",
                 "et": "Glükoolikhape",
                 "lt": "Gliukolio rūgštis",
                 "es": "Ácido glicólico",
                 "sv": "Glykolsyra",
                 "tr": "Glikolik Asit"
                }
               },
               {
                "value": "Lactic Acid",
                "text": {
                 "fr": "Acide Lactique",
                 "de": "Milchsäre",
                 "nl": "Melkzuur",
                 "it": "Acido Lattico",
                 "pl": "kwas mlekowy",
                 "lv": "Pienskābe",
                 "no": "Melkesyre",
                 "gr": "Λακτικό Οξύ",
                 "fi": "Maitohappo",
                 "ja": "乳酸",
                 "default": "Lactic Acid",
                 "et": "Piimhape",
                 "lt": "Pieno rūgštis",
                 "es": "Ácido láctico",
                 "sv": "Mjölksyra",
                 "tr": "Laktik Asit"
                }
               },
               {
                "value": "Other Hydroxy Acids",
                "text": {
                 "de": "Andere Hydroxysäuren",
                 "fr": "Autres Hydroxy Acides",
                 "nl": "Andere hydroxyzuren",
                 "it": "Altri idrossiacidi",
                 "pl": "Inne Kwasy Hydroksylowe",
                 "lv": "Citas Hidroksi Skābes",
                 "no": "Andre Hydroksysyre",
                 "gr": "Άλλα ΥδροξυΟξέα",
                 "fi": "Muut Hydroksihapot",
                 "ja": "その他のヒドロキシ酸",
                 "default": "Other Hydroxy Acids",
                 "et": "Muud hüdroksühapped",
                 "lt": "Kitos hidroksi rūgštys",
                 "es": "Otros hidroxiácidos",
                 "sv": "Andra hydroxisyror (AHA/BHA)",
                 "tr": "Diğer Hidroksi Asitler",
                 "vi": "Các Hydroxy Acid khác"
                }
               },
               {
                "value": "Any Exfoliating Scrubs",
                "text": {
                 "de": "Peeling-Peelings",
                 "nl": "Alle exfoliërende scrubs",
                 "it": "Qualsiasi scrub esfoliante",
                 "pl": "Inne Substancje Złuszczające",
                 "lv": "Jebkuri Pīlinga Skrubji",
                 "no": "En Type Eksfolierende Skrubb",
                 "fr": "Exfoliants À Grains",
                 "gr": "Απολεπιστικά Τριβής",
                 "fi": "Kuorintarakeet",
                 "ja": "角質除去スクラブ",
                 "default": "Any Exfoliating Scrubs",
                 "et": "Teradega kooorija",
                 "lt": "Bet kokie eksfolijuojantys šveitikliai",
                 "es": "Cualquier exfoliante",
                 "sv": "Valfri kornexfoliering/skrubb",
                 "tr": "Herhangi bir Eksfoliasyon Yapan Peeling",
                 "vi": "Bất kỳ hình thức tẩy da chết dạng hạt nào"
                }
               },
               {
                "value": "Vitamin A Derivatives (I.E., Retinol)",
                "text": {
                 "de": "Vitamin A-Derivate (Wie Retinol)",
                 "fr": "Dérivés De Vitamine A (Rétinol Etc)",
                 "nl": "Vitamine A-Derivaten (I.E., Retinol)",
                 "it": "Derivati di vitamina A (es. retinolo)",
                 "pl": "pochodne witaminy A (np. retinol)",
                 "lv": "Vitamīna A Atvasinājumi (I.E., Retinols)",
                 "no": "A-Vitaminsyrer (Som Retinol)",
                 "gr": "Παράγωγα Βιταμίνης Α (Όπως Η Ρετινόλη)",
                 "fi": "A-Vitamiinijohdannaiset, Kuten Retinoli",
                 "ja": "ビタミンA誘導体（例、レチノール）",
                 "default": "Vitamin A Derivatives (I.E., Retinol)",
                 "et": "A-vitamiini derivaadid (retinool)",
                 "lt": "Vitamino A dariniai (I. E., retinolis)",
                 "es": "Derivados de la vitamina A (por ejemplo, retinol)",
                 "sv": "Vitamin A-derivat (som Retinol)",
                 "tr": "A Vitamini Türevleri (örn. Retinol)",
                 "vi": "Các chiết xuất từ Vitamin A (ví dụ: Retinol)"
                }
               }
              ],
              "showOtherItem": true,
              "showNoneItem": true,
              "otherText": {
               "default": "other (describe)",
               "it": "Altro",
               "nl": "Andere",
               "ja": "その他",
               "es": "otros (describir)",
               "vi": "Khác (mô tả)"
              }
             },
             {
              "type": "checkbox",
              "name": "pregnant",
              "title": {
               "default": "Please specify if any of the following apply to you:",
               "fr": "Veuillez spécifier si l'une des situations suivantes vous concerne",
               "de": "Erkläre näher, falls folgendes auf dich zutrifft",
               "nl": "Geef aan of één van de volgende situaties op jou van toepassing is",
               "es": "por favor especifica si es alguno de los siguientes",
               "it": "Specifica se quanto segue è applicabile a te",
               "pl": "Określ, czy któreś z poniższych dotyczy Ciebie",
               "lv": "Lūdzu, norādiet, vai uz jums attiecas kāds no šiem punktiem",
               "no": "Vennligst spesifiser hvis noen av de følgende gjelder deg",
               "da": "Angiv venligst hvis noget af det følgende passer på dig",
               "gr": "Προσδιορίστε εάν ισχύει κάποιο από τα ακόλουθα",
               "fi": "Tarkenna, mikäli jokin seuraavista koskee sinua:",
               "ja": "次のいずれかに当てはまる場合記入して下さい。",
               "lt": "Nurodykite, ar jums tinka bent vienas iš šių punktų",
               "sv": "Vänligen specificera om något av följande stämmer in på dig:",
               "tr": "Lütfen aşağıdakilerden herhangi birinin sizin için geçerli olup olmadığını belirtin:",
               "vi": "Vui lòng chỉ rõ nếu bất kỳ điều nào sau đây áp dụng cho bạn"
              },
              "choices": [
               {
                "value": "Pregnant",
                "text": {
                 "fr": "Enceinte",
                 "nl": "Zwanger",
                 "pl": "Ciąża",
                 "lv": "Grūtniecība",
                 "no": "Gravid",
                 "gr": "Εγκυμοσύνη",
                 "fi": "Olen Raskaana",
                 "ja": "妊娠中",
                 "it": "Incinta",
                 "default": "Pregnant",
                 "et": "Rase",
                 "de": "schwanger",
                 "lt": "Nėščia",
                 "es": "embarazada",
                 "sv": "Gravid",
                 "tr": "Hamilelik",
                 "vi": "Mang thai"
                }
               },
               {
                "value": "Trying To Become Pregnant",
                "text": {
                 "fr": "Essaie D'être Enceinte",
                 "nl": "Proberen zwanger te worden",
                 "pl": "Próba zajścia w ciążę",
                 "lv": "Mēģina Palikt Stāvoklī",
                 "no": "Prøver Å Bli Gravid",
                 "gr": "Προσπαθείτε Να Μείνετε Έγκυος",
                 "fi": "Yritän Tulla Raskaaksi",
                 "ja": "妊娠の可能性",
                 "it": "Tentando una gravidanza",
                 "default": "Trying To Become Pregnant",
                 "et": "Proovite rasestuda",
                 "lt": "Bandant pastoti",
                 "es": "intentando quedarse embarazada",
                 "sv": "Försöker bli gravid",
                 "tr": "Hamile Kalmayı Planlamak",
                 "vi": "Đang có ý định mang thai"
                }
               },
               {
                "value": "Lactating",
                "text": {
                 "fr": "Allaitante",
                 "nl": "Borstvoeding geven",
                 "pl": "Laktacja",
                 "lv": "Laktācijas Periods",
                 "no": "Ammende",
                 "gr": "Γαλουχία",
                 "fi": "Imetän",
                 "ja": "授乳中",
                 "it": "Tentando una Allattamento",
                 "default": "Lactating",
                 "et": "Imetav",
                 "lt": "Laktacijos metu",
                 "es": "lactando",
                 "sv": "Ammar",
                 "tr": "Emzirme",
                 "vi": "Nuôi con bằng sữa mẹ"
                }
               },
               {
                "value": "Menstruating",
                "text": {
                 "fr": "Période menstruelle",
                 "nl": "Menstrueren",
                 "pl": "Miesiączka",
                 "lv": "Menstruācijas",
                 "no": "Menstruasjon",
                 "gr": "Εμμηνόρροια",
                 "fi": "Minulla On Kuukautiset",
                 "ja": "月経中",
                 "it": "Flusso mestruale",
                 "default": "Menstruating",
                 "et": "Menstruatsioon",
                 "lt": "Menstruacijos",
                 "es": "menstruando",
                 "sv": "Mensturation",
                 "tr": "Menstruasyon dönemi",
                 "vi": "Đang trong chu kỳ tháng"
                }
               },
               {
                "value": "Pre-Menstrual",
                "text": {
                 "fr": "Période pré-menstruelle",
                 "nl": "Pre-menstrueel",
                 "pl": "Przed miesiączką",
                 "lv": "Pirmsmenstruālais Cikls",
                 "no": "Pre-Menstruell",
                 "gr": "Προ-Εμμηνορροϊκή",
                 "fi": "Minulla On Kuukautisia Edeltäviä Oireita",
                 "ja": "月経前",
                 "it": "Periodo pre-mestruale",
                 "default": "Pre-Menstrual",
                 "et": "Menstruatsiooni eelne",
                 "lt": "Prieš mėnesines",
                 "sv": "Pre-menstruell",
                 "tr": "Menstruasyon öncesi",
                 "vi": "Trước chu kỳ tháng"
                }
               }
              ]
             },
             {
              "type": "boolean",
              "name": "light-based procedure",
              "title": {
               "default": "Have you received a cosmetic light-based procedure such as laser treatment, IPL, etc. within the last 6 weeks?",
               "it": "Hai mai fatto un trattamento cosmetico a base di luce, come un trattamento laser, IPL, ecc. nelle ultime 6 settimane?",
               "fi": "Oletko käynyt kosmeettisessa valohoidossa, kuten laserhoidossa, IPL:ssä jne., viimeisen kuuden viikon aikana?",
               "nl": "Heb je een cosmetische lichtprocedure zoals laser, IPL etc. ondergaan in de afgelopen 6 weken",
               "et": "Kas olete viimase 6 nädala jooksul saanud kosmeetilist valguspõhist protseduuri, näiteks laserravi, IPL jms?",
               "fr": "Avez-vous reçu un traitement esthétique comme le laser, la lumière pulsée, une exfoliation chimique etc. au cours des 2 derniers mois ?",
               "de": "Hast du innerhalb der letzten 6 Wochen eine kosmetische Lichtbehandlung wie etwa eine Laser Behandlung, IPL, o.ä. erhalten?",
               "gr": "Έχετε κάνει laser, IPLκλπ., τις τελευταίες 6 εβδομάδες;",
               "ja": "レザー治療やＩＰＬなどの美容的な光ベースの治療を過去６週間以内に受けたことがありますか？",
               "lv": "Vai pēdējo 6 nedēļu laikā esat saņēmis kosmētisko procedūru, kas balstīta uz gaismu, piemēram, ārstēšana ar lāzeri, IPL utt.?",
               "lt": "Ar per pastarąsias 6 savaites jums buvo atlikta kosmetinė šviesos pagrindu atlikta procedūra, tokia kaip gydymas lazeriu, IPL ir kt.?",
               "no": "Har du fått utført kosmetisk lysbehandling som laser, IPL, osv. i løpet av de siste 6 ukene?",
               "pl": "Czy w ciągu ostatnich 6 tygodni wykonywałaś/eś zabiegi kosmetyczne z wykorzystaniem światła takie jak laser, IPL itp.?",
               "es": "¿Ha recibido untratamiento cosmético basado en la luz, como un tratamiento con láser, IPL, etc. en las últimas 6 semanas?",
               "sv": "Har din hud behandlats med laser, IPL eller annan ljusbehandling de senaste 6 veckorna?",
               "tr": "Son 6 hafta içerisinde lazer tedavisi, IPL vb. ışın temelli kozmetik bir işlem yaptırdınız mı?",
               "vi": "Bạn có từng tiếp nhận liệu trình thẩm mỹ bằng ánh sáng nào như là trị liệu laser, IPL v.v.. trong vòng 6 tuần qua?"
              },
              "isRequired": true
             },
             {
              "type": "boolean",
              "name": "coldsores",
              "title": {
               "default": "Do you have active cold sores?",
               "it": "Hai delle lesioni al momento?",
               "fi": "Onko sinulla aktiivinen huuliherpes tällä hetkellä?",
               "nl": "Heb je last van een actieve koortsblaas?",
               "et": "Kas teil on aktiivseid külmaville/herpest?",
               "fr": "Souffrez-vous de boutons de fièvre ou d’herpès labial ?",
               "de": "Hast du momentan Fieberbläschen?",
               "gr": "Έχετε ενεργό έρπη;",
               "ja": "口唇ヘルペスが現在ありますか？",
               "lv": "Vai jums ir aktīvas aukstumpumpas?",
               "lt": "Ar nesate šiuo metu peršalęs?",
               "no": "Har du noen aktive munnsår?",
               "pl": "Czy masz aktywną opryszczkę?",
               "es": "¿Tienes herpes labial activo?",
               "sv": "Har du något aktivt munsår?",
               "tr": "Şu anda aktif uçuğunuz var mı?",
               "vi": "Bạn có đang bị mụn rộp?"
              },
              "isRequired": true
             },
             {
              "type": "boolean",
              "name": "botox",
              "title": {
               "default": "Have you received neurotoxin (Botox) injections within the past 2 weeks or other injectable procedures within the past 4 weeks?",
               "it": "Si è sottoposto a Botox o a qualsiasi altro trattamento simile nell'ultima settimana?",
               "fi": "Oletko käynyt Botox- tai muissa injektiohoidoissa viimeisen viikon aikana?",
               "nl": "Heb je Botox of andere injecties ontvangen in de afgelopen week?",
               "fr": "Avez-vous reçu des injections (acide hyaluronique, botox etc) au cours des 7 derniers jours ?",
               "gr": "Έχετε κάνει Botox ή άλλη ενέσιμη επεμβατική διαδικασία τις τελευταίες εβδομάδες;",
               "ja": "過去１週間以内にボトックスや注入治療処置を受けましたか？",
               "lv": "Vai pēdējās nedēļas laikā esat saņēmis Botox vai citas injekcijas procedūras?",
               "lt": "Ar per pastarąją savaitę buvo atlikta botokso ar kitos injekcinės procedūros?",
               "no": "Har du fått utført injeksjoner (botox/filler) i løpet av den siste uken?",
               "pl": "Czy korzystałeś z Botoxu lub innych procedur iniekcyjnych w ciągu ostatniego tygodnia?",
               "es": "¿Te has hecho algún tratamiento inyectable como botox en las últimas 4 semanas?",
               "sv": "Har du genomgått något kirurgiskt ingrepp (det senaste halvåret) eller fått injektion med botox eller filler (den senaste månaden)?",
               "tr": "Son 4 hafta içinde Botox veya başka bir enjeksiyon yaptırdınız mı?",
               "vi": "Bạn có từng tiếp nhận liệu trình tiêm Botox trong 2 tuần qua hoặc các quy trình tiêm chích khác nội trong 4 tuần qua không?"
              },
              "isRequired": true
             },
             {
              "type": "boolean",
              "name": "sunbathe tanning",
              "title": {
               "default": "Do you sunbathe or use tanning beds?",
               "it": "Prendi costantemente il sole o effettui lampade abbronzati?",
               "fi": "Otatko aurinkoa tai käytkö solariumissa?",
               "nl": "Zon je graag of ga je wel eens onder de zonnebank?",
               "et": "Kas päevitate või kasutate solaariumi?",
               "fr": "Avez-vous l’habitude de vous exposer au soleil ou d’avoir recourt aux UV ?",
               "de": "Sonnst du dich oder benutzt du eine Sonnenbank?",
               "gr": "Κάνετε ηλιοθεραπεία ή solarium;",
               "ja": "日光浴による日焼けや日焼けベッドを使用していますか？",
               "lv": "Vai jūs sauļojaties vai izmantojat solāriju?",
               "lt": "Ar Jūs deginotes ar buvote soliariume?",
               "no": "Bruker du solarium?",
               "pl": "Czy opalasz się lub korzystasz z solarium?",
               "es": "¿Tomas el sol o usas camas/cabinas de bornceado?",
               "sv": "Solar du aktivt utomhus eller i solarium?",
               "tr": "Güneşleniyor musunuz veya solaryuma gidiyor musunuz?",
               "vi": "Bạn có tắm nắng hoặc sử dụng giường tắm nắng không?"
              },
              "isRequired": true
             },
             {
              "type": "boolean",
              "name": "redness itching stinging",
              "title": {
               "default": "Do you experience redness, itching, or stinging on your skin?",
               "it": "La tua pelle soffre di rossore e prurito?",
               "fi": "Punoittaako, kutiaako tai kirveleekö ihosi?",
               "nl": "Ervaar je roodheid, jeuk of prikkelingen op de huid?",
               "et": "Kas teil esineb naha punetust, sügelust või kipitust?",
               "fr": "Ressentez-vous parfois des rougeurs ou démangeaisons ?",
               "de": "Hast du Rötungen, Jucken oder Stechen auf deiner Haut?",
               "gr": "Είχατε ποτέ την αίσθηση καψίματος, τσιμπήματος ή κνησμού στο δέρμα σας;",
               "ja": "赤み、かゆみ、または刺すような刺激感はありますか？",
               "lv": "Vai jums ir ādas apsārtums, nieze vai dzelonis?",
               "lt": "Ar jaučiate odos paraudimą, niežėjimą ar dilgčiojimą?",
               "no": "Hender det at huden din er rød, kløende eller stikkende?",
               "pl": "Czy odczuwasz zaczerwienienie, swędzenie lub pieczenie skóry?",
               "es": "¿sueles sufrir rojeces, picores o ardores en la piel?",
               "sv": "Upplever du någon form av klåda, känslighet eller rodnad?",
               "tr": "Cildinizde herhangi bir kızarıklık, kaşıntı veya batma hissi yaşıyor musunuz?",
               "vi": "Bạn có trải qua tấy đỏ, ngứa rát hoặc cảm giác châm chích trên da?"
              },
              "isRequired": true
             },
             {
              "type": "panel",
              "name": "microneedling panel",
              "elements": [
               {
                "type": "html",
                "name": "microneedling procedure",
                "html": {
                 "default": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">microneedling procedure description:</span></h2>\n\nThis skin care procedure is designed to stimulate the skin with micro-injuries to induce the production of collagen and elastin and improve the appearance of the skin. It is designed for use by skin care professionals.\nThe procedure is performed in a safe and precise manner utilizing a sterile Microneedling pen. The procedure is typically completed in 30- 60 minutes. The treatment time can vary based on the required treatment and anatomical site being treated.",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">mô tả quy trình vi kim: </span></h2>\n\nQuy trình chăm sóc da này được thiết kế để kích thích da bằng những tổn thương vi mô để tạo ra collagen và elastin và cải thiện vẻ ngoài của da. Nó được thiết kế để sử dụng bởi các chuyên gia chăm sóc da.\nQuy trình được thực hiện một cách an toàn và chính xác bằng cách sử dụng bút vi kim vô trùng. Quy trình này thường được hoàn thành trong 30-60 phút. Thời gian điều trị có thể khác nhau tùy theo yêu cầu điều trị và vị trí kết cấu đang được điều trị."
                }
               },
               {
                "type": "html",
                "name": "microneedling precautions",
                "html": {
                 "default": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Precautions &amp; Warnings</span></h3>\n<ol>\n<li>Discontinue auto-immune therapies or retinoid (Retin-A) and/or any form of skin treatment 3 days prior to procedure, under care and direction of a physician.</li>\n<li>Not for active acne, rosacea, or other inflammatory skin conditions. Not for skin with piercings in treatment area or open wounds.</li>\n<li>Not to be administered for 6 months to 1 year after isotretinoin (Accutane) regime.</li>\n<li>Not for clients with facial outbreaks such as herpes simplex virus. Medication must be taken per doctor&rsquo;s instructions.</li>\n<li>Not for clients with metal allergies or skin allergies.</li>\n<li>Any medications that would affect the characteristics of the skin should be stopped for two months prior to treatment, under the care and direction of a physician.</li>\n<li>Not for clients who have had a face lift or eyelid surgery within the past year, or dermabrasion, remodeling, deep chemical peels, or any surgical procedure on the treatment area within the previous 3 months.</li>\n<li>Not for clients who have had Botox, collagen, fat, or other methods of augmentation with injected materials in the treatment area within 4</li>\n<li>Not for clients who have excessively tanned or sunburned skin from the sun, tanning beds, or tanning creams within previous 2 weeks</li>\n<li>Avoid sweaty exercise and sun exposure for 72 hours post-procedure.</li>\n<li>Fitzpatrick skin types V-VI: pigment may darken prior to lightening.</li>\n<li>You may experience redness between 1-3 days.</li>\n<li>You may experience inflammation, itching, and burning.</li>\n</ol>",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Các biện pháp phòng ngừa &amp; Các cảnh báo</span></h3>\n<ol>\n<li>Ngừng sử dụng các liệu pháp tự miễn dịch hoặc retinoid (Retin-A) và/hoặc bất kỳ hình thức trị liệu da nào trong 3 ngày trước khi tiếp nhận liệu trình, dưới sự chăm sóc và hướng dẫn của nhân viên bác sỹ.</li>\n<li>Không dành cho các tình trạng da có mụn đang hoạt động, bị chàm rosacea, hoặc các tình trạng viêm sưng khác. Không dành cho làn da có xỏ khuyên trong vùng điều trị hoặc có vết thương mở.</li>\n<li>Không được dùng trong 6 tháng đến 1 năm sau khi sự dụng một chế độ isotretinoin (Accutane).</li>\n<li>Không dành cho các khách hàng có bệnh lây lan trên mặt như vi-rút herpes simplex. Thuốc phải được uống theo bác sỹ&rsquo;s hướng dẫn.</li>\n<li>Không dành cho khách hàng bị dị ứng với kim loại hoặc dị ứng da.</li>\n<li>Bất kỳ loại thuốc nào có ảnh hưởng đến đặc thù của da đều nên được ngừng sử dụng trong hai tháng trước khi tiếp nhận liệu trình, dưới sự chăm sóc và hướng dẫn của bác sỹ.</li>\n<li>Không dành cho các khách hàng đã thực hiện phẫu thuật nâng cơ mặt hoặc phẫu thuật mí mắt trong một năm qua, hoặc mài mòn, tu sửa, các dạng lột tẩy sâu bằng hoá chất, hoặc bất kỳ quy trình phẫu thuật nào trên khu vực điều trị trong 3 tháng trước.</li>\n<li>Không dành cho khách hàng đã thực hiện tiêm Botox, collagen, hút mỡ, hoặc các phương thức làm tăng lên bằng các vật liệu được tiêm vào tại khu vực điều trị trong 4 tháng qua.</li>\n<li>Không dành cho khách hàng làm nâu da quá mức hoặc da bị cháy nắng do tắm nắng, tắm nâu nhân tạo, hoặc kem làm nâu da trong vòng 2 tuần trước</li>\n<li>Tránh các bài tập ra nhiều mồ hôi và phơi nắng trong 72 giờ sau khi tiếp nhận liệu trình.</li>\n<li>Các loại da Fitzpatrick V-VI: sắc tố có thể sậm màu trước khi sáng lên. </li>\n<li>Bạn có thể trải qua tình trạng mẫn đỏ trong 1-3 ngày.</li>\n<li>Bạn có thể trải qua tình trạng viêm sưng, ngứa, và bỏng rát.</li>\n</ol>"
                }
               },
               {
                "type": "html",
                "name": "microneedling contraindications",
                "html": {
                 "default": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Contraindications for Microneedling:</span></h3>",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Các chống chỉ định đối với Vi kim Microneedling:</span></h3>"
                }
               },
               {
                "type": "checkbox",
                "name": "question1",
                "title": {
                 "default": "Please indicate below if any of the following apply to you:",
                 "vi": "Vui lòng ghi rõ bên dưới nếu bất kỳ điều nào sau đây áp dụng với bạn:"
                },
                "choices": [
                 {
                  "value": "Keloid scars",
                  "text": {
                   "default": "Keloid scars",
                   "vi": "Sẹo lồi"
                  }
                 },
                 {
                  "value": "History of eczema, psoriasis and other chronic conditions",
                  "text": {
                   "default": "History of eczema, psoriasis and other chronic conditions",
                   "vi": "Tiểu sử bệnh chàm, vảy nến, và các bệnh mãn tính khác."
                  }
                 },
                 {
                  "value": "History of actinic (solar) keratosis, diabetes, raised moles or warts on targeted area",
                  "text": {
                   "default": "History of actinic (solar) keratosis, diabetes, raised moles or warts on targeted area",
                   "vi": "Tiểu sử tình trạng tụ sừng quang hóa (ánh nắng), bệnh tiểu đường, nốt ruồi nổi lên hoặc mụn cóc trên vùng được nhắm đến."
                  }
                 },
                 {
                  "value": "History of hemophilia, irregular blood pressure, tuberculosis, liver function issues",
                  "text": {
                   "default": "History of hemophilia, irregular blood pressure, tuberculosis, liver function issues",
                   "vi": "Tiền sử bệnh máu loãng, huyết áp không đều, bệnh lao, các vấn đề về chức năng gan"
                  }
                 },
                 {
                  "value": "Susceptibility to capillary ectasia due to steroid use for extended periods",
                  "text": {
                   "default": "Susceptibility to capillary ectasia due to steroid use for extended periods",
                   "vi": "Độ mẫn cảm với chứng ectasia mao mạch do sử dụng steroid trong thời gian dài"
                  }
                 },
                 {
                  "value": "Scleroderma",
                  "text": {
                   "default": "Scleroderma",
                   "vi": "Bệnh xơ cứng bì"
                  }
                 },
                 {
                  "value": "Collagen vascular disease",
                  "text": {
                   "default": "Collagen vascular disease",
                   "vi": "Bệnh Mô Liên Kết Hỗn Hợp"
                  }
                 },
                 {
                  "value": "Cardiac abnormalities, pacemaker, blood clotting problems",
                  "text": {
                   "default": "Cardiac abnormalities, pacemaker, blood clotting problems",
                   "vi": "Các bất thường về tim, máy tạo nhịp tim, các vấn đề về đông máu"
                  }
                 },
                 {
                  "value": "Blood thinning medication",
                  "text": {
                   "default": "Blood thinning medication",
                   "vi": "Thuốc làm loãng máu"
                  }
                 },
                 {
                  "value": "Active bacterial or fungal infection; herpes simplex",
                  "text": {
                   "default": "Active bacterial or fungal infection; herpes simplex",
                   "vi": "Viêm nhiễm nấm hoặc vi khuẩn đang hoạt động; vi-rút herpes simplex"
                  }
                 },
                 {
                  "value": "Immunosuppression",
                  "text": {
                   "default": "Immunosuppression",
                   "vi": "Ức chế miễn dịch"
                  }
                 },
                 {
                  "value": "Facial melanosis",
                  "text": {
                   "default": "Facial melanosis",
                   "vi": "Bệnh hắc tố (nám) mặt"
                  }
                 },
                 {
                  "value": "Malignant tumors",
                  "text": {
                   "default": "Malignant tumors",
                   "vi": "Các khối u ác tính"
                  }
                 },
                 {
                  "value": "History of any type of cancer or suspicious lesions or moles in treatment area",
                  "text": {
                   "default": "History of any type of cancer or suspicious lesions or moles in treatment area",
                   "vi": "Tiền sử của bất kỳ loại ung thư hoặc các tổn thương hoặc nốt ruồi đáng ngờ trong khu vực điều trị"
                  }
                 },
                 {
                  "value": "Pregnant or nursing women",
                  "text": {
                   "default": "Pregnant or nursing women",
                   "vi": "Phụ nữ mang thai hoặc đang sinh sữa"
                  }
                 }
                ],
                "showOtherItem": true,
                "otherText": {
                 "default": "Any other medical condition contraindicated by the treating physician",
                 "vi": "Bất kỳ tình trạng sức khoẻ nào bị chống chỉ định bởi bác sỹ điều trị"
                }
               }
              ],
              "visibleIf": "{What treatment} = 'microneedling'",
              "showQuestionNumbers": "off"
             },
             {
              "type": "panel",
              "name": "panel2",
              "elements": [
               {
                "type": "html",
                "name": "question15",
                "html": {
                 "default": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">Fibroblast Skin Tightening procedure description:</span></h2>\n\nA minimally invasive, non-surgical treatment that uses plasma technology to help tighten, firm, and smooth skin as well as help reduce the appearance of wrinkles.",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">Mô tả quy trình Fibroblast:</span></h2>Sắp có nội dung mô tả."
                }
               },
               {
                "type": "html",
                "name": "question16",
                "html": {
                 "default": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Precautions &amp; Warnings</span></h3>\n<ol>\n<li>Do not use topical skin care products containing ingredients that may increase your skin sensitivity such as retinoids, exfoliants, topical antibiotics or hydroxy acids 3-5 days prior to your treatment.</li>\n<li>Avoid Accutane six months prior to your treatment. Check with your prescribing physician.</li>\n<li>Remove contact lenses before treatment.</li>\n<li>Avoid waxing, depilatory creams, or electrolysis to the area being treated 5 days prior to your treatment.</li>\n<li>Avoid IPL/Laser procedures, unprotected sun exposure, or sunburn at least 2 weeks prior to your treatment. </li>\n<li>Any medications that would affect the characteristics of the skin should be stopped for two months prior to treatment, under the care and direction of a physician.</li>\n<li>Not for clients who have had a face lift or eyelid surgery within the past year, or dermabrasion, remodeling, deep chemical peels, or any surgical procedure on the treatment area within the previous 3 months.</li>\n<li>Not for clients who have had Botox, collagen, fat, or other methods of augmentation with injected materials in the treatment area within 4 weeks</li>\n<li>Avoid experimenting with new skincare products before your treatment. Avoid alcohol and caffeine 24-48 hours before your treatment. Avoid wearing make-up or keep make-up to a minimum on the day of your treatment.</li>\n<li>Your skin will feel hot with a moderate burning sensation. You may experience swelling in and around the treated area and scabs will form.</li>\n<li>Avoid sweaty exercise and sun exposure for 72 hours post-procedure.</li>\n</ol>",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Các biện pháp phòng ngừa &amp; Các cảnh báo</span></h3>\n<ol>\n<li>Ngừng sử dụng các liệu pháp tự miễn dịch hoặc retinoid (Retin-A) và/hoặc bất kỳ hình thức trị liệu da nào trong 3 ngày trước khi tiếp nhận liệu trình, dưới sự chăm sóc và hướng dẫn của nhân viên bác sỹ.</li>\n<li>Không dành cho các tình trạng da có mụn đang hoạt động, bị chàm rosacea, hoặc các tình trạng viêm sưng khác. Không dành cho làn da có xỏ khuyên trong vùng điều trị hoặc có vết thương mở.</li>\n<li>Không được dùng trong 6 tháng đến 1 năm sau khi sự dụng một chế độ isotretinoin (Accutane).</li>\n<li>Không dành cho các khách hàng có bệnh lây lan trên mặt như vi-rút herpes simplex. Thuốc phải được uống theo bác sỹ&rsquo;s hướng dẫn.</li>\n<li>Không dành cho khách hàng bị dị ứng với kim loại hoặc dị ứng da.</li>\n<li>Bất kỳ loại thuốc nào có ảnh hưởng đến đặc thù của da đều nên được ngừng sử dụng trong hai tháng trước khi tiếp nhận liệu trình, dưới sự chăm sóc và hướng dẫn của bác sỹ.</li>\n<li>Không dành cho các khách hàng đã thực hiện phẫu thuật nâng cơ mặt hoặc phẫu thuật mí mắt trong một năm qua, hoặc mài mòn, tu sửa, các dạng lột tẩy sâu bằng hoá chất, hoặc bất kỳ quy trình phẫu thuật nào trên khu vực điều trị trong 3 tháng trước.</li>\n<li>Không dành cho khách hàng đã thực hiện tiêm Botox, collagen, hút mỡ, hoặc các phương thức làm tăng lên bằng các vật liệu được tiêm vào tại khu vực điều trị trong 4 tháng qua.</li>\n<li>Không dành cho khách hàng làm nâu da quá mức hoặc da bị cháy nắng do tắm nắng, tắm nâu nhân tạo, hoặc kem làm nâu da trong vòng 2 tuần trước</li>\n<li>Tránh các bài tập ra nhiều mồ hôi và phơi nắng trong 72 giờ sau khi tiếp nhận liệu trình.</li>\n<li>Các loại da Fitzpatrick V-VI: sắc tố có thể sậm màu trước khi sáng lên. </li>\n<li>Bạn có thể trải qua tình trạng mẫn đỏ trong 1-3 ngày.</li>\n<li>Bạn có thể trải qua tình trạng viêm sưng, ngứa, và bỏng rát.</li>\n</ol>"
                }
               },
               {
                "type": "html",
                "name": "question17",
                "html": {
                 "default": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Contraindications for Fibroblast Skin Tightening:</span></h3>\n",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Các chống chỉ định đối với liệu pháp Fibroblast:</span></h3>"
                }
               },
               {
                "type": "checkbox",
                "name": "question18",
                "title": {
                 "default": "Please indicate below if any of the following apply to you:",
                 "vi": "Vui lòng ghi rõ bên dưới nếu bất kỳ điều nào sau đây áp dụng với bạn:"
                },
                "choices": [
                 {
                  "value": "Pregnancy",
                  "text": {
                   "default": "Pregnancy",
                   "vi": "Mang thai"
                  }
                 },
                 {
                  "value": "Keloid or hypertrophic scarring",
                  "text": {
                   "default": "Keloid or hypertrophic scarring",
                   "vi": "Sẹo lồi hoặc phì đại"
                  }
                 },
                 {
                  "value": "History of eczema, psoriasis, or other chronic conditions",
                  "text": {
                   "default": "History of eczema, psoriasis, or other chronic conditions",
                   "vi": "Tiền sử bệnh chàm, bệnh vẩy nến hoặc các tình trạng mãn tính khác"
                  }
                 },
                 {
                  "value": "History of actinic (solar) keratosis",
                  "text": {
                   "default": "History of actinic (solar) keratosis",
                   "vi": "Tiền sử dày sừng quang hóa (do ánh nắng)"
                  }
                 },
                 {
                  "value": "History of herpes simplex infections",
                  "text": {
                   "default": "History of herpes simplex infections",
                   "vi": "Tiền sử nhiễm herpes simplex"
                  }
                 },
                 {
                  "value": "History of diabetes or diabetic",
                  "text": {
                   "default": "History of diabetes or diabetic",
                   "vi": "Tiền sử bệnh tiểu đường hoặc đái tháo đường"
                  }
                 },
                 {
                  "value": "Presence of raised moles, warts, or any raised lesions on the targeted area",
                  "text": {
                   "default": "Presence of raised moles, warts, or any raised lesions on the targeted area",
                   "vi": "Sự hiện diện của nốt ruồi, mụn cóc hoặc bất kỳ tổn thương nào nổi lên ở khu vực tập trung"
                  }
                 },
                 {
                  "value": "Isotretinoin (sometimes marketed as Accutane) taken within the last 6-12 months, or other medically prescribed exfoliants unless directed by a physician",
                  "text": {
                   "default": "Isotretinoin (sometimes marketed as Accutane) taken within the last 6-12 months, or other medically prescribed exfoliants unless directed by a physician",
                   "vi": "Sử dụng Isotretinoin (đôi khi được bán trên thị trường là Accutane) trong vòng 6-12 tháng qua, hoặc các chất tẩy tế bào chết được kê toa y tế trừ khi có chỉ định của bác sĩ"
                  }
                 },
                 {
                  "value": "Surgical procedures or under a physician's care",
                  "text": {
                   "default": "Surgical procedures or under a physician's care",
                   "vi": "Các thủ tục phẫu thuật hoặc dưới sự chăm sóc của bác sĩ"
                  }
                 },
                 {
                  "value": "Excessive sun exposure within the last 24 hours",
                  "text": {
                   "default": "Excessive sun exposure within the last 24 hours",
                   "vi": "Tiếp xúc quá nhiều với ánh nắng trong vòng 24 giờ qua"
                  }
                 },
                 {
                  "value": "Open wounds, rashes or infections in the treatment area",
                  "text": {
                   "default": "Open wounds, rashes or infections in the treatment area",
                   "vi": "Vết thương chưa lành, phát ban hoặc nhiễm trùng trong khu vực điều trị"
                  }
                 },
                 {
                  "value": "Haemophiliac",
                  "text": {
                   "default": "Haemophiliac",
                   "vi": "Bệnh máu khó đông"
                  }
                 },
                 {
                  "value": "Laser resurfacing within the last 3 months; chemical or mechanical peeling within the last 1-2 weeks",
                  "text": {
                   "default": "Laser resurfacing within the last 3 months; chemical or mechanical peeling within the last 1-2 weeks",
                   "vi": "Tái tạo bề mặt da bằng laser trong vòng 3 tháng qua; lột da bằng hóa chất hoặc cơ học trong vòng 1-2 tuần qua"
                  }
                 },
                 {
                  "value": "Impaired barrier",
                  "text": {
                   "default": "Impaired barrier",
                   "vi": "Lớp hàng rào bị hư tổn"
                  }
                 }
                ],
                "showOtherItem": true,
                "otherText": {
                 "default": "Any other medical condition contraindicated by the treating physician",
                 "vi": "Bất kỳ tình trạng sức khoẻ nào bị chống chỉ định bởi bác sỹ điều trị"
                }
               }
              ],
              "visibleIf": "{What treatment} = 'fibroblast'",
              "showQuestionNumbers": "off"
             },
             {
              "type": "panel",
              "name": "dermaplaning panel",
              "elements": [
               {
                "type": "html",
                "name": "question2",
                "html": {
                 "default": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">dermaplaning procedure description:</span></h2>\n\nDermaplaning is a mechanical and superficial form of exfoliation. This type of treatment can be used on all skin concerns but is largely used to target pigmentation, congestion and removal of vellus hair.",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">mô tả quy trình cạo lông tơ dermaplaning:</span></h2>\n\nDermaplaning là một hình thức tẩy da chết trên bề mặt và dạng cơ học. Loại liệu pháp này có thể được dùng cho tất cả các lo lắng về da, nhưng chủ yếu được dùng để nhắm vào sự hình thành sắc tố, tắc nghẽn và loại bỏ lông tơ."
                }
               },
               {
                "type": "html",
                "name": "question3",
                "html": {
                 "default": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Precautions &amp; Warnings</span></h3>\n<ol>\n<li>Discontinue products containing any exfoliating agents (Retinoic Acid, Tretinoin, Retinol, Benzoyl Peroxide, Glycolic Acid, Salicylic Acid, astringents, etc.) 24-48 hours before treatment.</li>\n<li>A history of herpes or cold sores may require a course of anti-viral medication pre- and post-treatment.</li>\n<li>Your professional skin therapist will prescribe appropriate products to help enhance results and/or minimize potential side effects.</li>\n</ol>",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Các biện pháp phòng ngừa &amp; cảnh báo</span></h3>\n<ol>\n<li>Ngừng sử dụng các sản phẩm có chứa bất kỳ chất tẩy tế bào da chết nào (Axít Retinoic, Tretinoin, Retinol, Benzoyl Peroxide, Axít Glycolic, Axít Salicylic, các chất làm se, v.v...) trong 24-48 giờ trước khi tiếp nhận liệu trình.</li>\n<li>Tiền sử bị vi-rút herpes hoặc mụn rộp có thể cần sử dụng một liều chống vi-rút trước và sau khi tiếp nhận trị liệu. </li>\n<li>Chuyên viên da chuyên nghiệp của bạn sẽ kê toa sản phẩm phù hợp để giúp đẩy mạnh các kết quả và/hoặc giảm thiểu khả năng của các tác dụng phụ. </li>\n</ol>"
                }
               },
               {
                "type": "html",
                "name": "question4",
                "html": {
                 "default": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Contraindications for Dermaplaning:</span></h3>",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Các chống chỉ định đối với liệu pháp Dermaplaning:</span></h3>"
                }
               },
               {
                "type": "checkbox",
                "name": "question5",
                "title": {
                 "default": "Please indicate below if any of the following apply to you:",
                 "vi": "Vui lòng ghi rõ bên dưới nếu bất kỳ điều nào sau đây áp dụng với bạn:"
                },
                "choices": [
                 {
                  "value": "Current, inflamed acne lesions",
                  "text": {
                   "default": "Current, inflamed acne lesions",
                   "vi": "Các tổn thương mụn trứng cá bị viêm sưng, hiện có"
                  }
                 },
                 {
                  "value": "Skin cancer",
                  "text": {
                   "default": "Skin cancer",
                   "vi": "Ung thư da"
                  }
                 },
                 {
                  "value": "Active cold sores",
                  "text": {
                   "default": "Active cold sores",
                   "vi": "Mụn rộp đang hoạt động"
                  }
                 },
                 {
                  "value": "Uncontrolled diabetes",
                  "text": {
                   "default": "Uncontrolled diabetes",
                   "vi": "Bệnh tiểu đường không kiểm soát"
                  }
                 },
                 {
                  "value": "Dermatitis",
                  "text": {
                   "default": "Dermatitis",
                   "vi": "Viêm da"
                  }
                 },
                 {
                  "value": "Open skin lesions",
                  "text": {
                   "default": "Open skin lesions",
                   "vi": "Các tổn thương da chưa lành"
                  }
                 },
                 {
                  "value": "Use of Accutane currently or in the past six months",
                  "text": {
                   "default": "Use of Accutane currently or in the past six months",
                   "vi": "Hiện đang sử dụng Accutane hoặc trong sáu tháng qua"
                  }
                 },
                 {
                  "value": "Use of prescription Retinol within the past 24-48 hours",
                  "text": {
                   "default": "Use of prescription Retinol within the past 24-48 hours",
                   "vi": "Sử dụng Retinol theo kê toa trong 24-48 giờ qua"
                  }
                 }
                ],
                "otherText": {
                 "default": "Any other medical condition contraindicated by the treating physician",
                 "vi": "Bất kỳ tình trạng sức khoẻ nào bị chống chỉ địng bởi bác sỹ điều trị"
                }
               }
              ],
              "visibleIf": "{What treatment} = 'dermaplaning'",
              "showQuestionNumbers": "off"
             },
             {
              "type": "panel",
              "name": "IPL Panel",
              "elements": [
               {
                "type": "html",
                "name": "question6",
                "html": {
                 "default": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">IPL procedure description:</span></h2>\n\nIPL (Intense Pulsed Light) is a non-invasive light therapy procedure that directs different wavelengths of light toward skin. IPL is often used to reduce the appearance of uneven skin tone including age spots, sun damage, freckles, broken capillaries, and rosacea.",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">Mô tả quy trình Ánh Sáng Xung Động Cao IPL:</span></h2>\n\nIPL (Ánh Sáng Xung Động Cao) là một liệu trình ánh sáng không xâm lấn phóng các bước sóng ánh sáng khác nhau lên da. IPL thường được dùng để giảm biểu hiện của tông màu da không đồng đều bao gồm đồi mồi, hư tổn do ánh nắng, tàn nhang, mao mạch bị vỡ, và bệnh trứng cá đỏ rosacea."
                }
               },
               {
                "type": "html",
                "name": "question7",
                "html": {
                 "default": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Precautions &amp; Warnings</span></h3>\n<ol>\n<li>Not for clients who have excessively tanned or sunburned skin from the sun, tanning beds, or tanning creams within previous 4</li>\n<li>Discontinue photosensitizing medications, such as Accutane (Isotretinoin), at least 6 months before treatment. Discontinue medications such as Retin-A, Renova, and Tazorac 3-7 days before treatment.</li>\n<li>Discontinue waxing, chemical depilatories and chemical peels on the treatment area within 1-2 weeks of treatment.</li>\n<li>Shave dark hair or prevalant vellus hair 12-24 hours before treatment.</li>\n<li>IPL is not recommended for darker skin (LES or Fitzpatrick skin types 4 and higher). Please consult a physician.</li>\n<li>Avoid sweaty exercise and sun exposure for 72 hours post-procedure.</li>\n<li>You may experience redness for up to 2 days.</li>\n<li>You may experience tightness, inflammation, itching and</li>\n<li>Pigmentation may appear darker after treatment. <strong>Avoid picking or scrubbing skin for 1-2 weeks, as it can cause scarring.</strong></li>\n<li>Your professional skin therapist will prescribe appropriate products to help enhance results and/or minimize potential side effects.</li>\n</ol>",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Các biện pháp phòng ngừa  &amp; Cảnh báo</span></h3>\n<ol>\n<li>Không dành cho khách hàng có làn da bị rám nắng hoặc cháy nắng quá mức do phơi nắng, sử dụng giường hoặc kem làm nâu da trong 48 giờ trước đó.</li>\n<li>Ngừng sử dụng các loại thuốc gây nhạy cảm quang học, như là Accutane (Isotretinoin), ít nhất 6 tháng trước khi tiếp nhận liệu trình. Ngừng sử dụng các loại thuốc như Retin-A, Renova, và Tazorac 3-7 6 tháng trước khi tiếp nhận liệu trình.</li>\n<li>Ngừng tẩy lông, các loại thuốc làm rụng lông và các loại lột tẩy hoá học trên khu vực điều trị trong 1-2 tuần 6 tháng sau khi tiếp nhận liệu trình.</li>\n<li>Cạo các vùng lông sậm màu hoặc lông tơ mọc nhiều 12-24 giờ 6 tháng trước khi tiếp nhận liệu trình.</li>\n<li>Không khuyên dùng IPL cho làn da sậm màu (LES hoặc da thuộc Fitzpatrick loại 4 và cao hơn). Vui lòng tham khảo ý kiến của bác sỹ.</li>\n<li>Tránh tập thể dục ra nhiều mồ hôi và phơi nắng trong 72 giờ sau khi tiếp nhận liệu trình.</li>\n<li>Bạn có thể bị mẩn đỏ trong tối đa 2 ngày.</li>\n<li>Bạn có thể trải qua cảm giác căng chặt, viêm sưng, ngứa rát và</li>\n<li>Sắc tố da có thể sẫm màu hơn sau khi trị liệu. <strong>Tránh khợi hoặc chà sát da trong 1-2 tuần, vì nó có thể gây sẹo. </strong></li>\n<li>Chuyên viên da chuyên nghiệp của bạn sẽ kê toa các sản phẩm phù hợp để giúp đẩy mạnh kết quả và/hoặc giảm thiểu khả năng tác dụng phụ.</li>\n</ol>"
                }
               },
               {
                "type": "html",
                "name": "question8",
                "html": {
                 "default": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Contraindications for IPL:</span></h3>",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Các chống chỉ định đối với IPL:</span></h3>"
                }
               },
               {
                "type": "checkbox",
                "name": "question9",
                "title": {
                 "default": "Please indicate below if any of the following apply to you:",
                 "vi": "Vui lòng ghi rõ bên dưới nếu bất kỳ điều nào sau đây áp dụng với bạn:"
                },
                "choices": [
                 {
                  "value": "Epilepsy or history of seizures",
                  "text": {
                   "default": "Epilepsy or history of seizures",
                   "vi": "Bệnh động kinh hoặc tiền sử co giật"
                  }
                 },
                 {
                  "value": "Lupus",
                  "text": {
                   "default": "Lupus",
                   "vi": "Bệnh lupus"
                  }
                 },
                 {
                  "value": "Use of photosensitizing medications (including some antibiotics)",
                  "text": {
                   "default": "Use of photosensitizing medications (including some antibiotics)",
                   "vi": "Sử dụng các loại thuốc gây nhạy cảm quang học (bao gồm một vài loại kháng sinh)"
                  }
                 },
                 {
                  "value": "Use of St. John’s Wort within the past 3 months",
                  "text": {
                   "default": "Use of St. John’s Wort within the past 3 months",
                   "vi": "Sử dụng St. John’s Wort (một loại thảo mộc dùng để chống trầm cảm) trong 3 tháng qua"
                  }
                 },
                 {
                  "value": "Areas with permanent make-up or tattoos (including cosmetic)",
                  "text": {
                   "default": "Areas with permanent make-up or tattoos (including cosmetic)",
                   "vi": "Các khu vực có hình xăm hoặc trang điểm vĩnh viễn (bao gồm mỹ phẩm)"
                  }
                 },
                 {
                  "value": "Vitiligo",
                  "text": {
                   "default": "Vitiligo",
                   "vi": "Bệnh bạch biến"
                  }
                 },
                 {
                  "value": "Pregnant or nursing women",
                  "text": {
                   "default": "Pregnant or nursing women",
                   "vi": "Phụ nữ mang thai hoặc đang sinh sữa"
                  }
                 },
                 {
                  "value": "Cancer",
                  "text": {
                   "default": "Cancer",
                   "vi": "Ung thư"
                  }
                 },
                 {
                  "value": "History of keloid scars",
                  "text": {
                   "default": "History of keloid scars",
                   "vi": "Tiền sử sẹo lồi"
                  }
                 },
                 {
                  "value": "Severe dermatitis, active inflammatory acne or eczema on targeted area",
                  "text": {
                   "default": "Severe dermatitis, active inflammatory acne or eczema on targeted area",
                   "vi": "Viêm da nghiêm trọng, mụn viêm sưng đang hoạt động hoặc chàm trên khu vực được nhắm đến"
                  }
                 },
                 {
                  "value": "Active infections (e.g. herpes simplex) on targeted area",
                  "text": {
                   "default": "Active infections (e.g. herpes simplex) on targeted area",
                   "vi": "Các viêm nhiễm đang hoạt động (Ví dụ: Herpes Simplex) trên khu vực được nhắm đến"
                  }
                 },
                 {
                  "value": "Use of Accutane currently or in the past six months",
                  "text": {
                   "default": "Use of Accutane currently or in the past six months",
                   "vi": "Hiện đang sử dụng Accutane hoặc trong sáu tháng qua"
                  }
                 },
                 {
                  "value": "Use of diabetes medication",
                  "text": {
                   "default": "Use of diabetes medication",
                   "vi": "Sử dụng thuốc điều trị bệnh tiểu đường"
                  }
                 },
                 {
                  "value": "Use of Vitamin A or hydroxy acids within the past 60 days",
                  "text": {
                   "default": "Use of Vitamin A or hydroxy acids within the past 60 days",
                   "vi": "Sử dụng Vitamin A hoặc Axít Hydroxy trong 60 ngày qua"
                  }
                 },
                 {
                  "value": "Presence of a pacemaker",
                  "text": {
                   "default": "Presence of a pacemaker",
                   "vi": "Hiện đang cài máy trợ tim"
                  }
                 },
                 {
                  "value": "Presence of surgical metal pins or plates under targeted area",
                  "text": {
                   "default": "Presence of surgical metal pins or plates under targeted area",
                   "vi": "Hiện đang cài ghim hoặc đệm kim loại phẫu thuật dưới khu vực được nhắm đến"
                  }
                 },
                 {
                  "value": "Use of blood-thinning agents (i.e. Aspirin, Ibuprofen, Aleve) within the past week",
                  "text": {
                   "default": "Use of blood-thinning agents (i.e. Aspirin, Ibuprofen, Aleve) within the past week",
                   "vi": "Sử dụng các chất làm loãng máu (ví dụ: Aspirin, Ibuprofen, Aleve) trong một tuần qua"
                  }
                 }
                ],
                "otherText": {
                 "default": "Any other medical condition contraindicated by the treating physician",
                 "vi": "Bất kỳ tình trạng sức khoẻ nào bị chống chỉ địng bởi bác sỹ điều trị"
                }
               }
              ],
              "visibleIf": "{What treatment} = 'IPL'",
              "showQuestionNumbers": "off"
             },
             {
              "type": "panel",
              "name": "nanoinfusion",
              "elements": [
               {
                "type": "html",
                "name": "question19",
                "html": {
                 "default": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">NanoInfusion procedure description:</span></h2>\n\nNanoInfusion goes by various names such as\nMicroexfoliation, Nanoneedling or Nano exfoliation.\nIt is a non-invasive procedure that involves the use of\na pen style modality and nano-tips instead of needles.\nIt uses very tiny cones formed of stainless steel that do\nnot penetrate the skin, but do help with resurfacing and\nproduct infusion. This is an alternative treatment for\nclients who do not want any downtime or those who\nmay be contraindicated to microneedling. It can also\nimprove skin texture, boost hydration and address signs\nof premature skin aging. The most immediate, visible\nchange in the skin is a hydrated glow.",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">Mô tả quy trình Ánh Sáng Xung Động Cao IPL:</span></h2>\n\nIPL (Ánh Sáng Xung Động Cao) là một liệu trình ánh sáng không xâm lấn phóng các bước sóng ánh sáng khác nhau lên da. IPL thường được dùng để giảm biểu hiện của tông màu da không đồng đều bao gồm đồi mồi, hư tổn do ánh nắng, tàn nhang, mao mạch bị vỡ, và bệnh trứng cá đỏ rosacea."
                }
               },
               {
                "type": "html",
                "name": "question20",
                "html": {
                 "default": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Precautions &amp; Warnings</span></h3>\n<ol>\n<li> Discontinue auto-immune therapies or retinoid 9Retin-A) and/or any form of active skin care product 3 days\nprior to procedure, under care and direction of a physician. </li>\n<li> Not for active acne, rosacea, or other inflammatory skin conditions. Not for skin with piercings in targeted area\nor open wounds</li>\n<li>Not for clients with metal allergies or skin allergies.</li>\n<li>Any medications that would affect the characteristics of the skin should be stopped for two months prior to\ntreatment, under the care and direction of a physician.</li>\n<li>Not for clients who have had neurotoxin (Botox) injectable, or other injectables such as collagen, fat, or other\nmethods of augmentation in the targeted area within 14 days.</li>\n<li>No waxing, depilatory creams, or methods of hair removal to the targeted area for at least 5 days prior.\nNo IPL/laser hair removal 14 days prior. </li>\n<li> Not for clients who have excessively tanned or sunburned skin from the sun, tanning bed within previous 14 days. </li>\n<li>Avoid sweaty exercise, sauna, steam, and sun exposure for 3 days post-treatment. </li>\n<li>You may experience redness between 1-3 days. </li>\n<li> You may experience inflammation, itching, and burning. </li>\n<li>Consult a physician if any irritation persists.</li>\n<li> Raised scars, lesions, or moles in the targeted area will not be treated.</li>\n<li> Seek physician’s approval if you are pregnant or nursing.</li>\n</ol>",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Các biện pháp phòng ngừa  &amp; Cảnh báo</span></h3>\n<ol>\n<li>Không dành cho khách hàng có làn da bị rám nắng hoặc cháy nắng quá mức do phơi nắng, sử dụng giường hoặc kem làm nâu da trong 48 giờ trước đó.</li>\n<li>Ngừng sử dụng các loại thuốc gây nhạy cảm quang học, như là Accutane (Isotretinoin), ít nhất 6 tháng trước khi tiếp nhận liệu trình. Ngừng sử dụng các loại thuốc như Retin-A, Renova, và Tazorac 3-7 6 tháng trước khi tiếp nhận liệu trình.</li>\n<li>Ngừng tẩy lông, các loại thuốc làm rụng lông và các loại lột tẩy hoá học trên khu vực điều trị trong 1-2 tuần 6 tháng sau khi tiếp nhận liệu trình.</li>\n<li>Cạo các vùng lông sậm màu hoặc lông tơ mọc nhiều 12-24 giờ 6 tháng trước khi tiếp nhận liệu trình.</li>\n<li>Không khuyên dùng IPL cho làn da sậm màu (LES hoặc da thuộc Fitzpatrick loại 4 và cao hơn). Vui lòng tham khảo ý kiến của bác sỹ.</li>\n<li>Tránh tập thể dục ra nhiều mồ hôi và phơi nắng trong 72 giờ sau khi tiếp nhận liệu trình.</li>\n<li>Bạn có thể bị mẩn đỏ trong tối đa 2 ngày.</li>\n<li>Bạn có thể trải qua cảm giác căng chặt, viêm sưng, ngứa rát và</li>\n<li>Sắc tố da có thể sẫm màu hơn sau khi trị liệu. <strong>Tránh khợi hoặc chà sát da trong 1-2 tuần, vì nó có thể gây sẹo. </strong></li>\n<li>Chuyên viên da chuyên nghiệp của bạn sẽ kê toa các sản phẩm phù hợp để giúp đẩy mạnh kết quả và/hoặc giảm thiểu khả năng tác dụng phụ.</li>\n</ol>"
                }
               },
               {
                "type": "html",
                "name": "question21",
                "html": {
                 "default": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Contraindications for nanoinfusion:</span></h3>",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Các chống chỉ định đối với IPL:</span></h3>"
                }
               },
               {
                "type": "checkbox",
                "name": "question22",
                "title": {
                 "default": "Please indicate below if any of the following apply to you:",
                 "vi": "Vui lòng ghi rõ bên dưới nếu bất kỳ điều nào sau đây áp dụng với bạn:"
                },
                "choices": [
                 {
                  "value": "keloid scars",
                  "text": {
                   "default": "keloid scars",
                   "vi": "Bệnh động kinh hoặc tiền sử co giật"
                  }
                 },
                 {
                  "value": "active eczema, psoriasis, and other chronic",
                  "text": "active eczema, psoriasis, and other chronic condition flare up"
                 },
                 {
                  "value": "condition flare up",
                  "text": "history of actinic (solar) keratosis, diabetes, raised moles or warts on targeted area"
                 },
                 {
                  "value": "pregnant or nursing",
                  "text": {
                   "default": "pregnant or nursing",
                   "vi": "Sử dụng các loại thuốc gây nhạy cảm quang học (bao gồm một vài loại kháng sinh)"
                  }
                 },
                 {
                  "value": "scleroderma",
                  "text": {
                   "default": " scleroderma",
                   "vi": "Sử dụng St. John’s Wort (một loại thảo mộc dùng để chống trầm cảm) trong 3 tháng qua"
                  }
                 },
                 {
                  "value": "collagen vascular disease",
                  "text": {
                   "default": " collagen vascular disease",
                   "vi": "Các khu vực có hình xăm hoặc trang điểm vĩnh viễn (bao gồm mỹ phẩm)"
                  }
                 },
                 {
                  "value": "active bacterial or fungal infection",
                  "text": {
                   "default": "active bacterial or fungal infection",
                   "vi": "Bệnh bạch biến"
                  }
                 },
                 {
                  "value": "history of any type of cancer",
                  "text": {
                   "default": "history of any type of cancer",
                   "vi": "Phụ nữ mang thai hoặc đang sinh sữa"
                  }
                 }
                ],
                "otherText": {
                 "default": "Any other medical condition contraindicated by the treating physician",
                 "vi": "Bất kỳ tình trạng sức khoẻ nào bị chống chỉ địng bởi bác sỹ điều trị"
                }
               }
              ],
              "visibleIf": "{What treatment} = 'nano_infusion'",
              "showQuestionNumbers": "off"
             },
             {
              "type": "panel",
              "name": "Pro Power Peel Panel",
              "elements": [
               {
                "type": "html",
                "name": "question10",
                "html": {
                 "default": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">pro power peel procedure description:</span></h2>\n\nThis skin care procedure is designed to accelerate skin rejuvenation through removal of the outer layers of the skin. \n<div>\nThe procedure is performed utilizing chemical peel agents including hydroxy acids. The procedure is typically completed in 30 - 60 minutes. The treatment time can\nvary based on the required treatment and anatomical site being treated.\n</div>",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">mô tả quy trình lột tẩy quyền năng pro power peel:</span></h2>\n\nQuy trình chăm sóc da này được thiết kế để giúp kích thích khả năng trẻ hoá da thông qua việc loại bỏ các lớp da bên ngoài. \n<div>\nLiệu trình này được thực hiện bằng cách tận dụng các chất lột tẩy hoá học bao gồm các axít hydroxy. Liệu trình thường được hoàn thành trong 30-60 phút. Thời lượng của liệu pháp có thể khác nhau dựa trên trị liệu được yêu cầu và khu vực da được điều trị. \n</div>"
                }
               },
               {
                "type": "html",
                "name": "question11",
                "html": {
                 "default": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Precautions &amp; Warnings</span></h3>\n<ol>\n<li>Discontinue auto-immune therapies or retinoid (Retin-A) and/or any form of skin treatment 3 days prior to procedure, under care and direction of a physician.</li>\n<li>Not for active acne, rosacea, or other inflammatory skin conditions. Not for skin with piercings in treatment area or open wounds.</li>\n<li>Not to be administered for 6 months to 1 year after isotretinoin (Accutane) regime.</li>\n<li>Not for clients with facial outbreaks such as herpes simplex virus. Medication must be taken per doctor&rsquo;s instructions.</li>\n<li>Not for clients with skin allergies.</li>\n<li>Any medications that would affect the characteristics of the skin should be stopped for two months prior to treatment, under the care and direction of a physician.</li>\n<li>Not for clients who have had a face lift or eyelid surgery within the past year, or dermabrasion, remodeling, deep chemical peels, or any surgical procedure on the treatment area within the previous 3 months.</li>\n<li>Not for clients who have had Botox, collagen, fat, or other methods of augmentation with injected materials in the treatment area within 4 weeks</li>\n<li>Not for clients who have excessively tanned or sunburned skin from the sun, tanning beds, or tanning creams within previous 2 weeks</li>\n<li>Avoid sweaty exercise and sun exposure for 72 hours post-procedure.</li>\n<li>Fitzpatrick skin types V-VI: pigment may darken prior to lightening.</li>\n<li>You may experience redness between 1-3 days.</li>\n<li>You may experience inflammation, itching, and burning.</li>\n<li>Consult a physician if any irritation persists.</li>\n<li>Use a sunscreen, wear protective clothing, and limit sun exposure for 2 weeks afterwards.</li>\n<li>Follow the instructions of your professional skin therapist.</li>\n</ol>",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Các biện pháp phòng ngừa &amp; Cảnh báo</span></h3>\n<ol>\n<li>Ngừng các liệu pháp miễn dịch tự động hoặc retinoid (Retin-A) và/hoặc bất kỳ hình thức trị liệu da nào trong 3 ngày trước khi tiếp nhận liệu trình, dưới sự chăm sóc và hướng dẫn của bác sỹ. </li>\n<li>Không dành cho da đang có mụn trứng cá hoạt động, bệnh trứng cá đỏ rosacea, hoặc các tình trạng da viêm sưng khác. Không dành cho da có xỏ khuyên ở khu vực trị liệu hoặc có vết thương chưa lành.</li>\n<li>Không thực hiện trong 6 tháng đến 1 năm sau chế độ isotretinoin (Accutane).</li>\n<li>Không dành cho những khách hàng đang có tình trạng bộc phát trên khuôn mặt như vi rút herpes simplex. Thuốc phải được dùng theo hướng dẫn của bác sỹ&rsquo;s instructions.</li>\n<li>Không dành cho khách hàng có dị ứng da.</li>\n<li>Bất kỳ loại thuốc nào có thể ảnh hưởng đến các đặc điểm của da nên được ngừng sử dụng trong hai tháng trước khi điều trị, dưới sự chăm sóc và hướng dẫn của bác sỹ.</li>\n<li>Không dành cho những khách hàng đã phẫu thuật nâng cơ mặt hoặc cắt mí mắt trong vòng một năm qua, hoặc mài mòn da, các phương thức tu sửa, lột tẩy hoá học sâu, hoặc bất kỳ quy trình phẫu thuật nào trên vùng điều trị trong vòng 3 tháng trước đó.</li>\n<li>Không dành cho những khách hàng đã tiêm Botox, collagen, mỡ, hoặc các phương pháp làm căng đầy bằng vật chất được tiêm vào ở vùng điều trị trong vòng 4 tuần</li>\n<li>Không dành cho những khách hàng có làn da rám nắng hoặc cháy nắng quá mức do ánh nắng mặt trời, giường  hoặc kem làm nâu da trong vòng 2 tuần trước đó</li>\n<li>Tránh tập thể dục ra nhiều mồ hôi và tiếp xúc với ánh nắng mặt trời trong 72 giờ sau khi tiếp nhận liệu trình. </li>\n<li>Loại da Fitzpatrick V-VI: sắc tố có thể sậm màu trước khi sáng lên.</li>\n<li>Bạn có thể bị mẩn đỏ từ 1-3 ngày.</li>\n<li>Bạn có thể bị viêm sưng, ngứa và rát.</li>\n<li>Tham khảo ý kiến ​​bác sĩ nếu bất kỳ kích ứng nào vẫn tiếp diễn.</li>\n<li>Sử dụng kem chống nắng, mặc quần áo bảo vệ và hạn chế tiếp xúc với ánh nắng trong 2 tuần sau đó. </li>\n<li>Làm theo hướng dẫn của chuyên viên da chuyên nghiệp của bạn.</li>\n</ol>"
                }
               },
               {
                "type": "html",
                "name": "question12",
                "html": {
                 "default": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Contraindications for Pro Power Peel:</span></h3>",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Các chống chỉ định đối với Lột Tẩy Quyền Năng Pro Power Peel:</span></h3>"
                }
               },
               {
                "type": "checkbox",
                "name": "question13",
                "title": {
                 "default": "Please indicate below if any of the following apply to you:",
                 "vi": "Vui lòng ghi rõ bên dưới nếu bất kỳ điều nào sau đây áp dụng với bạn:"
                },
                "choices": [
                 {
                  "value": "item1",
                  "text": {
                   "default": "Recent Surgery or Scar Tissue",
                   "vi": "Phẫu thuật gần đây hoặc có mô sẹo"
                  }
                 },
                 {
                  "value": "item2",
                  "text": {
                   "default": "Open wounds/Abrasions/Sunburn",
                   "vi": "Vết thương chưa lành/Trầy xước/Cháy nắng"
                  }
                 },
                 {
                  "value": "item3",
                  "text": {
                   "default": "Bruises/Swelling",
                   "vi": "Các vết bầm/Sưng tấy"
                  }
                 },
                 {
                  "value": "item4",
                  "text": {
                   "default": "Undiagnosed Lumps or Lesions",
                   "vi": "Các tổn thương hoặc khối u chưa được chẩn đoán"
                  }
                 },
                 {
                  "value": "item5",
                  "text": {
                   "default": "Eczema or Psoriasis",
                   "vi": "Bệnh chàm Eczema hoặc vảy nến"
                  }
                 },
                 {
                  "value": "item6",
                  "text": {
                   "default": "Broken Bones or Injuries",
                   "vi": "Gãy xương hoặc các chấn thương"
                  }
                 },
                 {
                  "value": "item7",
                  "text": {
                   "default": "High temperature",
                   "vi": "Nhiệt độ cao"
                  }
                 },
                 {
                  "value": "item8",
                  "text": {
                   "default": "Cardiovascular Conditions",
                   "vi": "Các tình trạng tim mạch"
                  }
                 },
                 {
                  "value": "item9",
                  "text": {
                   "default": "Neurological diseases",
                   "vi": "Các bệnh trạng thuộc về thần kinh"
                  }
                 },
                 {
                  "value": "item10",
                  "text": {
                   "default": "Chemotherapy and Radiotherapy",
                   "vi": "Liệu pháp hoá trị và xạ trị"
                  }
                 },
                 {
                  "value": "item11",
                  "text": {
                   "default": "Viral infections such as colds or flu, Herpes Simplex",
                   "vi": "Các viêm nhiễm vi-rút như cảm lạnh hoặc cảm cúm, Herpes Simplex"
                  }
                 },
                 {
                  "value": "item12",
                  "text": {
                   "default": "Bacterial infections such as Impetigo, Conjunctivitis",
                   "vi": "Các viêm nhiễm vi khuẩn như viêm kết mạc, bệnh chốc lở"
                  }
                 },
                 {
                  "value": "item13",
                  "text": {
                   "default": "Fungal infections such as Ringworm or Pityriasis Versicolor",
                   "vi": "Các viêm nhiễm nấm như nấm ngoài da hoặc bệnh lang ben"
                  }
                 },
                 {
                  "value": "item14",
                  "text": {
                   "default": "Parasitic infections such as scabies or head lice",
                   "vi": "Các viêm nhiễm ký sinh trùng như ghẻ hoặc chấy, rận"
                  }
                 },
                 {
                  "value": "item15",
                  "text": "HIV"
                 },
                 {
                  "value": "item16",
                  "text": {
                   "default": "Pregnancy",
                   "vi": "Mang thai"
                  }
                 },
                 {
                  "value": "item17",
                  "text": {
                   "default": "Epilepsy",
                   "vi": "Bệnh động kinh"
                  }
                 }
                ],
                "otherText": {
                 "default": "Other",
                 "nl": "Andere",
                 "et": "Muu",
                 "fi": "Muu",
                 "fr": "Autres",
                 "de": "Andere",
                 "gr": "Άλλο",
                 "it": "Altro",
                 "ja": "その他",
                 "lv": "Cits",
                 "lt": "Kita",
                 "no": "Annet",
                 "pl": "Inny",
                 "es": "otros",
                 "sv": "Annat",
                 "tr": "Diğer",
                 "vi": "Khác"
                }
               }
              ],
              "visibleIf": "{What treatment} = 'pro_power_peel'",
              "showQuestionNumbers": "off"
             },
             {
              "type": "panel",
              "name": "luminfusion_panel",
              "elements": [
               {
                "type": "html",
                "name": "luminfusion_description",
                "html": {
                 "default": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">luminfusion procedure description:</span></h2>\n\nLuminFusion is a non-invasive combination procedure that uses professional-grade product and nanoinfusion and LED technology. Nanoinfusion technology uses a pen style modality and nano-tips instead of needles. It uses tiny cones formed of stainless steel or silicon that do not penetrate the skin but do help with resurfacing and product infusion. LED technology uses visible light to enhance natural processes within the skin by increasing cellular energy. LuminFusion is an alternative treatment for clients who do not want any downtime or those who may be contraindicated to microneedling. It can improve skin luminosity, smooth fine lines and wrinkles and instantly reveal radiant skin.",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h2 style=\"text-align: left; font-family: Helvetica\"><span style=\"color: #5d94d6;\">mô tả quy trình lột tẩy quyền năng pro power peel:</span></h2>\n\nQuy trình chăm sóc da này được thiết kế để giúp kích thích khả năng trẻ hoá da thông qua việc loại bỏ các lớp da bên ngoài. \n<div>\nLiệu trình này được thực hiện bằng cách tận dụng các chất lột tẩy hoá học bao gồm các axít hydroxy. Liệu trình thường được hoàn thành trong 30-60 phút. Thời lượng của liệu pháp có thể khác nhau dựa trên trị liệu được yêu cầu và khu vực da được điều trị. \n</div>"
                }
               },
               {
                "type": "html",
                "name": "luminfusion_precautions",
                "html": {
                 "default": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Precautions &amp; Warnings</span></h3>\n<ol>\n<li> Discontinue auto-immune therapies or retinoid like Retin-A and/or any form of active skin care product 3 days prior to procedure, under care and direction of a physician.</li>\n<li>Not for active acne, rosacea, or other inflammatory skin conditions. Not for skin with piercings in targeted area or open wounds</li>\n<li>Not for clients with metal allergies or skin allergies.</li>\n<li>Any medications that would affect the characteristics of the skin should be stopped for two months prior to treatment, under the care and direction of a physician.</li>\n<li>Not for clients who have had neurotoxin (Botox) injectable, or other injectables such as collagen, fat, or other methods of augmentation in the targeted area within 14 days.</li>\n<li>No waxing, depilatory creams, or methods of hair removal to the targeted area for at least 5 days prior. No IPL/laser hair removal 14 days prior.</li>\n<li>Not for clients who have excessively tanned or sunburned skin from the sun, tanning bed within previous 14 days.</li>\n<li>Avoid sweaty exercise, sauna, steam, and sun exposure for 3 days post-treatment.</li>\n<li>You may experience redness between 1-3 days.</li>\n<li>You may experience inflammation, itching, and burning.</li>\n<li>Consult a physician if any irritation persists.</li>\n<li>Raised scars, lesions, or moles in the targeted area will not be treated.</li>\n<li>Seek physician’s approval if you are pregnant or nursing.</li>\n</ol>",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Các biện pháp phòng ngừa &amp; Cảnh báo</span></h3>\n<ol>\n<li>Ngừng các liệu pháp miễn dịch tự động hoặc retinoid (Retin-A) và/hoặc bất kỳ hình thức trị liệu da nào trong 3 ngày trước khi tiếp nhận liệu trình, dưới sự chăm sóc và hướng dẫn của bác sỹ. </li>\n<li>Không dành cho da đang có mụn trứng cá hoạt động, bệnh trứng cá đỏ rosacea, hoặc các tình trạng da viêm sưng khác. Không dành cho da có xỏ khuyên ở khu vực trị liệu hoặc có vết thương chưa lành.</li>\n<li>Không thực hiện trong 6 tháng đến 1 năm sau chế độ isotretinoin (Accutane).</li>\n<li>Không dành cho những khách hàng đang có tình trạng bộc phát trên khuôn mặt như vi rút herpes simplex. Thuốc phải được dùng theo hướng dẫn của bác sỹ&rsquo;s instructions.</li>\n<li>Không dành cho khách hàng có dị ứng da.</li>\n<li>Bất kỳ loại thuốc nào có thể ảnh hưởng đến các đặc điểm của da nên được ngừng sử dụng trong hai tháng trước khi điều trị, dưới sự chăm sóc và hướng dẫn của bác sỹ.</li>\n<li>Không dành cho những khách hàng đã phẫu thuật nâng cơ mặt hoặc cắt mí mắt trong vòng một năm qua, hoặc mài mòn da, các phương thức tu sửa, lột tẩy hoá học sâu, hoặc bất kỳ quy trình phẫu thuật nào trên vùng điều trị trong vòng 3 tháng trước đó.</li>\n<li>Không dành cho những khách hàng đã tiêm Botox, collagen, mỡ, hoặc các phương pháp làm căng đầy bằng vật chất được tiêm vào ở vùng điều trị trong vòng 4 tuần</li>\n<li>Không dành cho những khách hàng có làn da rám nắng hoặc cháy nắng quá mức do ánh nắng mặt trời, giường  hoặc kem làm nâu da trong vòng 2 tuần trước đó</li>\n<li>Tránh tập thể dục ra nhiều mồ hôi và tiếp xúc với ánh nắng mặt trời trong 72 giờ sau khi tiếp nhận liệu trình. </li>\n<li>Loại da Fitzpatrick V-VI: sắc tố có thể sậm màu trước khi sáng lên.</li>\n<li>Bạn có thể bị mẩn đỏ từ 1-3 ngày.</li>\n<li>Bạn có thể bị viêm sưng, ngứa và rát.</li>\n<li>Tham khảo ý kiến ​​bác sĩ nếu bất kỳ kích ứng nào vẫn tiếp diễn.</li>\n<li>Sử dụng kem chống nắng, mặc quần áo bảo vệ và hạn chế tiếp xúc với ánh nắng trong 2 tuần sau đó. </li>\n<li>Làm theo hướng dẫn của chuyên viên da chuyên nghiệp của bạn.</li>\n</ol>"
                }
               },
               {
                "type": "html",
                "name": "question27",
                "html": {
                 "default": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Contraindications for Luminfusion:</span></h3>",
                 "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> peau</span></h1>",
                 "vi": "<h3 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\">Các chống chỉ định đối với Lột Tẩy Quyền Năng Pro Power Peel:</span></h3>"
                }
               },
               {
                "type": "checkbox",
                "name": "luminfusion_contraindications",
                "title": {
                 "default": "Please indicate below if any of the following apply to you:",
                 "vi": "Vui lòng ghi rõ bên dưới nếu bất kỳ điều nào sau đây áp dụng với bạn:"
                },
                "choices": [
                 {
                  "value": "Recent Surgery or Scar Tissue",
                  "text": {
                   "default": "Recent Surgery or Scar Tissue",
                   "vi": "Phẫu thuật gần đây hoặc có mô sẹo"
                  }
                 },
                 {
                  "value": "Open wounds/Abrasions/Sunburn",
                  "text": {
                   "default": "Open wounds/Abrasions/Sunburn",
                   "vi": "Vết thương chưa lành/Trầy xước/Cháy nắng"
                  }
                 },
                 {
                  "value": "Bruises/Swelling",
                  "text": {
                   "default": "Bruises/Swelling",
                   "vi": "Các vết bầm/Sưng tấy"
                  }
                 },
                 {
                  "value": "Undiagnosed Lumps or Lesions",
                  "text": {
                   "default": "Undiagnosed Lumps or Lesions",
                   "vi": "Các tổn thương hoặc khối u chưa được chẩn đoán"
                  }
                 },
                 {
                  "value": "Eczema or Psoriasis",
                  "text": {
                   "default": "Eczema or Psoriasis",
                   "vi": "Bệnh chàm Eczema hoặc vảy nến"
                  }
                 },
                 {
                  "value": "Broken Bones or Injuries",
                  "text": {
                   "default": "Broken Bones or Injuries",
                   "vi": "Gãy xương hoặc các chấn thương"
                  }
                 },
                 {
                  "value": "High temperature",
                  "text": {
                   "default": "High temperature",
                   "vi": "Nhiệt độ cao"
                  }
                 },
                 {
                  "value": "Cardiovascular Conditions",
                  "text": {
                   "default": "Cardiovascular Conditions",
                   "vi": "Các tình trạng tim mạch"
                  }
                 },
                 {
                  "value": "Neurological diseases",
                  "text": {
                   "default": "Neurological diseases",
                   "vi": "Các bệnh trạng thuộc về thần kinh"
                  }
                 },
                 {
                  "value": "Chemotherapy and Radiotherapy",
                  "text": {
                   "default": "Chemotherapy and Radiotherapy",
                   "vi": "Liệu pháp hoá trị và xạ trị"
                  }
                 },
                 {
                  "value": "Viral infections such as colds or flu, Herpes Simplex",
                  "text": {
                   "default": "Viral infections such as colds or flu, Herpes Simplex",
                   "vi": "Các viêm nhiễm vi-rút như cảm lạnh hoặc cảm cúm, Herpes Simplex"
                  }
                 },
                 {
                  "value": "Bacterial infections such as Impetigo, Conjunctivitis",
                  "text": {
                   "default": "Bacterial infections such as Impetigo, Conjunctivitis",
                   "vi": "Các viêm nhiễm vi khuẩn như viêm kết mạc, bệnh chốc lở"
                  }
                 },
                 {
                  "value": "Fungal infections such as Ringworm or Pityriasis Versicolor",
                  "text": {
                   "default": "Fungal infections such as Ringworm or Pityriasis Versicolor",
                   "vi": "Các viêm nhiễm nấm như nấm ngoài da hoặc bệnh lang ben"
                  }
                 },
                 {
                  "value": "Parasitic infections such as scabies or head lice",
                  "text": {
                   "default": "Parasitic infections such as scabies or head lice",
                   "vi": "Các viêm nhiễm ký sinh trùng như ghẻ hoặc chấy, rận"
                  }
                 },
                 "HIV",
                 {
                  "value": "Pregnancy",
                  "text": {
                   "default": "Pregnancy",
                   "vi": "Mang thai"
                  }
                 },
                 {
                  "value": "Epilepsy",
                  "text": {
                   "default": "Epilepsy",
                   "vi": "Bệnh động kinh"
                  }
                 }
                ],
                "otherText": {
                 "default": "Other",
                 "nl": "Andere",
                 "et": "Muu",
                 "fi": "Muu",
                 "fr": "Autres",
                 "de": "Andere",
                 "gr": "Άλλο",
                 "it": "Altro",
                 "ja": "その他",
                 "lv": "Cits",
                 "lt": "Kita",
                 "no": "Annet",
                 "pl": "Inny",
                 "es": "otros",
                 "sv": "Annat",
                 "tr": "Diğer",
                 "vi": "Khác"
                }
               }
              ],
              "visibleIf": "{What treatment} = 'lumin_fusion'",
              "showQuestionNumbers": "off"
             }
            ],
            "showQuestionNumbers": "onpanel"
           },
           {
            "type": "panel",
            "name": "panel1",
            "elements": [
             {
              "type": "html",
              "name": "consenttitle",
              "html": {
               "default": "<h1 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">client</span> consent</span></h1>",
               "fr": "<h1 style=\"text-align: left; font-family: Helvetica Neue Light;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">votre</span> santÃ©</span></h1>",
               "it": "<h1 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">consenso</span> del cliente</span></h1>",
               "ja": "<h1 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">パッチテストの</span>承諾</span></h1>",
               "vi": "<h1 style=\"text-align: left; font-family: Helvetica;\"><span style=\"color: #5d94d6;\"><span style=\"color: #999999;\">khách hàng</span> đồng ý</span></h1>"
              }
             },
             {
              "type": "html",
              "name": "Consentvalid",
              "html": {
               "default": "<p><strong>THIS CONSENT FORM IS VALID UNTIL ALL OR PART IS REVOKED BY ME IN WRITING.</strong></p>",
               "vi": "<p><strong>PHIẾU ĐỒNG Ý NÀY CÓ HIỆU LỰC TRỪ KHI TÔI HUỶ BỎ TẤT CẢ HOẶC MỘT PHẦN CỦA THÔNG TIN ĐÃ ĐỒNG Ý CUNG CẤP</strong></p>"
              }
             },
             {
              "type": "html",
              "name": "consent",
              "html": {
               "default": "I understand that results will vary between individuals. I understand that although I may see a change after my first treatment, I may require a series of sessions to obtain my desired outcome.\nThe procedure contraindications, precautions and warnings have been explained to me including alternative methods, as have the advantages and disadvantages. I am advised that though good results are expected, the possibility and nature of complications cannot be fully anticipated.\nTherefore, there can be no guarantee as expressed or implied either as to the success or other result of the treatment. I am aware that the results of this treatment with Dermalogica are not permanent as natural degradation will occur over time.\nI have read this consent form and I understand the information contained in it.\nI have had the opportunity to ask any questions about the treatment, including risks or alternatives and acknowledge that all my questions about the procedure have been answered in a satisfactory manner.",
               "fr": "Je comprends que les résultats varient d'une personne à l'autre. Je comprends que même si je peux voir un changement après mon premier traitement, je peux avoir besoin d'une série de séances pour obtenir le résultat souhaité.\nLes contre-indications de la procédure, les précautions et les avertissements m'ont été expliqués, y compris les méthodes alternatives, ainsi que les avantages et les inconvénients. On m'informe que même si de bons résultats sont attendus, la possibilité et la nature des complications ne peuvent pas être totalement anticipées.\nPar conséquent, il ne peut y avoir aucune garantie, expresse ou implicite, quant au succès ou à tout autre résultat du traitement. Je suis conscient que les résultats de ce traitement avec Dermalogica ne sont pas permanents car une dégradation naturelle se produira avec le temps.\nJ'ai lu ce formulaire de consentement et je comprends les informations qu'il contient.\nJ'ai eu l'occasion de poser des questions sur le traitement, y compris les risques ou les alternatives et reconnais avoir répondu de manière satisfaisante à toutes mes questions sur la procédure.",
               "vi": "Tôi hiểu rằng các kết quả sẽ khác nhau giữa các cá nhân. Tôi hiểu rằng mặc dù tôi có thể thấy sự thay đổi sau lần điều trị đầu tiên, nhưng tôi có thể cần một chuỗi các buổi liệu pháp để đạt được kết quả mong muốn của mình.\nCác chống chỉ định, biện pháp phòng ngừa và cảnh báo của liệu trình đã được giải thích cho tôi bao gồm cả các phương pháp thay thế, cũng như có những ưu điểm và nhược điểm. Tôi được khuyên rằng mặc dù kết quả tốt được mong đợi nhưng không thể biết trước hết khả năng và bản chất của các biến chứng.\nDo đó, không thể có sự đảm bảo như được diễn đạt hoặc ngụ ý về sự thành công hoặc kết quả khác của trị liệu. Tôi biết rằng các kết quả của trị liệu này với Dermalogica này không phải là vĩnh viễn bởi vì sự suy giảm tự nhiên sẽ xảy ra theo thời gian.\nTôi đã đọc mẫu đồng ý này và tôi hiểu thông tin có trong đó.\nTôi đã có cơ hội để hỏi bất kỳ câu hỏi nào về phương pháp điều trị, bao gồm cả rủi ro hoặc các lựa chọn thay thế và nhận thức rằng tất cả các câu hỏi của tôi về quy trình đã được giải đáp một cách thỏa đáng."
              }
             },
             {
              "type": "signaturepad",
              "name": "consent_signature",
              "title": {
               "default": "I confirm that the information I have provided on this form is accurate, to the best of my knowledge, and that I have not withheld any information that will be relevant to my consultation. Client signature:",
               "it": "Firma",
               "nl": "Ik bevestig hiermee dat alle vragen naar waarheid zijn ingevuld en dat ik geen informatie heb achtergehouden die relevant kan zijn voor de behandeling.",
               "et": "Kinnitan, et mulle teadaolevalt on sellel vormil esitatud teave täpne ja ma ei ole varjanud minu konsulteerimisel olulist teavet.",
               "ja": "クライアントシグネチャー",
               "vi": "Tôi xác nhận rằng thông tin tôi đã cung cấp trên biểu mẫu này là hoàn toàn chính xác, theo hiểu biết tốt nhất của tôi, và rằng tôi đã không che dấu bất kỳ thông tin nào liên quan đến phần tư vấn của tôi. Ký tên bên dưới."
              },
              "isRequired": true,
              "signatureWidth": 500,
              "penColor": "#5e93db"
             },
             {
              "type": "text",
              "name": "date_signed_client",
              "title": {
               "default": "Date Signed:",
               "vi": "Ngày ký tên:"
              },
              "defaultValueExpression": "today()",
              "isRequired": true,
              "inputType": "date",
              "penColor": "#5e93db"
             }
            ],
            "showQuestionNumbers": "off"
           }
          ]
         }
        ],
        "showTitle": false
       }    
    return json;
}






